// 1.3.40: YUIChat 项目 - 国际化配置 (添加官网落地页多语言支持)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  zh: {
    translation: {
      // App Title
      appTitle: 'YUIChat',
      appSubtitle: '企业知识库服务',
      
      // Knowledge Base
      knowledgeBase: '知识库管理',
      knowledgeBaseTitle: '企业知识资源太多,太杂?',
      knowledgeBaseSubtitle: '文件、音视频、网站,5秒快速创建知识库',
      createNow: '立即创建',
      createOnlineDoc: '创建在线文档',
      allDocuments: '全部文档',
      searchFileName: '搜索文件名/网址',
      uploadKnowledgeBase: '上传知识库',
      localFiles: '本地文件',
      supportedFormats: '支持格式: txt、pdf、docx、pptx、xlsx',
      dragFilesHere: '将文件拖拽到此,或者',
      selectFiles: '选择文件',
      maxFileSize: '单个文件最大 50 MB',
      maxAudioFileSize: '单个文件最大1GB',
      supportsMultipleFiles: '支持上传多个文件',
      singleFileUploadOnly: '仅支持单个文件上传',
      audioSupportedFormats: '支持格式:mp4、mp3、wav',
      selectedFile: '已选择文件',
      waitForTraining: '文件上传后需要等待训练为"已完成"',
      maxDocumentChars: '根据您的套餐,最多支持为 10000 字文档生成问题',
      canCloseDuringUpload: '上传进程中可关闭该窗口继续其他操作',
      selectedFiles: '已选择文件',
      previousStep: '上一步',
      autoGenerateQA: '自动生成问答',
      startUpload: '开始上传',
      uploading: '上传中...',
      uploadSuccess: '上传成功', // 1.6.26
      uploadFailed: '上传失败', // 1.6.26
      maxFilesLimit: '单次最多上传 {{max}} 个文件', // 1.6.26
      maxFilesExceeded: '超过文件数量限制，已自动截取前 {{max}} 个文件', // 1.6.26
      urlProcessing: '正在处理', // 1.6.27
      urlSuccess: '处理成功', // 1.6.27
      urlFailed: '处理失败', // 1.6.27
      analyzeAudioVideo: '分析音视频',
      audioVideoSubtitle: '支持多种音视频转字幕文件',
      websiteAnalysis: '网站分析',
      websiteAnalysisDesc: '输入网站链接,分析网站信息',
      
      // Document Status
      statusProcessing: '正在学习',
      statusCompleted: '学习成功',
      statusFailed: '学习失败',
      uploadedWaitingProcessing: '上传成功，正在处理中...',
      
      // Chat Interface
      chatMode: '对话',
      chatWelcomeTitle: 'AI 知识库助手',
      chatWelcomeMessage: '基于您的知识库，我可以回答您的问题！',
      chatInputPlaceholder: '告诉我您的问题...',
      chatError: '出错了',
      
      // Common
      save: '保存',
      cancel: '取消',
      delete: '删除',
      edit: '编辑',
      close: '关闭',
      loading: '加载中...',
      error: '错误',
      success: '成功',
      
      // Navigation & Sidebar
      projectSettings: '项目设置',
      testChat: 'AI对话',
      externalShare: '外部分享',
      dashboard: '数据看板',
      allProjects: '全部项目',
      createProject: '创建项目',
      exampleProject: '示例项目',
      conversationData: '对话数据',
      currentProject: '当前项目',
      currentOrganization: '当前组织', // 1.4.6
      selectOrganization: '选择组织', // 1.4.6
      business: '企业', // 1.4.6
      personal: '个人', // 1.4.6
      owner: '所有者', // 1.4.6
      member: '成员', // 1.4.6
      account: '账户',
      user: '用户',
      signOut: '登出',
      defaultProject: '默认项目',
      accountCenter: '账号中心', // 1.2.6
      feedback: '意见反馈', // 1.2.6
      back: '返回', // 1.2.29
      
      // Account Center Page - 1.2.29
      accountCenterDescription: '管理您的个人信息和账号设置',
      basicInfo: '基本信息',
      displayName: '显示名称',
      pleaseEnterName: '请输入您的名字',
      emailCannotBeChanged: '邮箱地址无法更改',
      loginMethod: '登录方式',
      thirdPartyLoginNote: '您使用第三方账号登录，密码由该服务提供商管理。如需修改密码，请在对应的服务提供商处进行修改。',
      changePassword: '修改密码',
      newPassword: '新密码',
      pleaseEnterNewPassword: '请输入新密码',
      confirmPassword: '确认密码',
      pleaseConfirmPassword: '请再次输入新密码',
      updatePassword: '更新密码',
      updating: '更新中...',
      updateProfileSuccess: '资料更新成功',
      updateProfileFailed: '资料更新失败',
      updatePasswordSuccess: '密码更新成功',
      updatePasswordFailed: '密码更新失败',
      passwordMismatch: '两次输入的密码不一致',
      
      // Feedback Page - 1.2.29
      feedbackDescription: '我们非常重视您的意见和建议，请告诉我们您的想法',
      note: '提示',
      feedbackNote: '您的反馈对我们非常重要，我们会认真阅读每一条反馈并持续改进产品。',
      
      // 1.3.85: 认证错误消息多语言
      authErrors: {
        invalidCredentials: '邮箱或密码错误',
        emailNotConfirmed: '邮箱尚未验证，请查收验证邮件',
        userAlreadyRegistered: '该邮箱已被注册',
        credentialTooShort: '密码至少8位，须包含字母、数字和特殊符号',
        invalidEmailFormat: '邮箱格式不正确',
        signupDisabled: '注册功能已禁用',
        emailRateLimitExceeded: '邮件发送次数过多，请稍后再试',
        rateLimitExceeded: '出于安全考虑，请60秒后再试',
        networkError: '网络连接异常，请检查网络后重试',
        serviceUnavailable: '服务暂时不可用，请稍后重试',
        invalidOrExpiredResetToken: '重置链接无效或已过期',
      },

      // 1.5.3: API/组织相关错误消息翻译
      apiErrors: {
        // 邀请相关
        invalidInvitationLink: '无效的邀请链接',
        invitationNoLongerValid: '此邀请已失效',
        invitationExpired: '邀请链接已过期',
        invitationMaxUsage: '此邀请链接已达到最大使用次数',
        invitationWrongEmail: '此邀请链接仅限特定邮箱使用',
        alreadyMember: '您已经是该组织的成员',
        organizationMaxMembers: '该组织已达到成员人数上限',
        userAlreadyMember: '该用户已是组织成员',
        userNotFound: '未找到该邮箱对应的用户',
        // 权限相关
        onlyOwnersCanInvite: '仅所有者可以邀请成员',
        onlyOwnersCanRemove: '仅所有者可以移除成员',
        onlyOwnersCanChangeRole: '仅所有者可以更改成员角色',
        cannotRemoveOwner: '无法移除其他所有者，请先更改其角色',
        cannotLeaveAsOnlyOwner: '您是唯一的所有者，无法离开。请先转让所有权',
        organizationNeedsOwner: '组织必须至少有一位所有者',
        accessDenied: '访问被拒绝：您不是该组织的成员',
        // 组织相关
        organizationNotFound: '未找到组织',
        memberNotFound: '未找到该成员',
        userAlreadyHasOrg: '用户已有组织',
        invalidRole: '无效的角色，必须是所有者或成员',
        invalidCompanySize: '无效的企业规模',
        invalidPlanType: '无效的套餐类型',
        onlyOwnerCanUpgrade: '仅所有者可以升级套餐',
        // 知识库相关
        knowledgeBaseNotFound: '未找到知识库',
        onlyCreatorOrOwnerCanShare: '仅创建者或组织所有者可以更改共享设置',
        // 通用
        operationFailed: '操作失败，请重试',
        notAuthenticated: '未登录',
        noOrganizationFound: '未找到组织',
      },
      
      // 1.3.80: 订阅与套餐多语言
      subscriptionAndPlan: '订阅与套餐',
      organizationInfo: '企业信息',
      businessOrganization: '企业组织',
      personalWorkspace: '个人工作区',
      workspaceSuffix: '的工作区', // 1.5.1: 动态工作区名称后缀
      
      // 1.4.2: 企业信息 Tab
      // 1.5.7: 添加缺失的翻译键（storageUsage, publicLinkUsage, 订阅状态）
      orgInfo: {
        noOrganization: '未找到组织信息',
        basicInfo: '基本信息',
        roleOwner: '所有者',
        roleMember: '成员',
        orgType: '组织类型',
        businessOrg: '企业组织',
        personalOrg: '个人组织',
        currentPlan: '当前套餐',
        memberCount: '成员人数',
        storageQuota: '存储配额',
        publicLinkQuota: '公开链接配额',
        storageUsage: '存储用量',
        publicLinkUsage: '访问次数统计',
        joinedAt: '加入时间',
        resourcesAndMembership: '资源与成员资格',
        organizationOwner: '组织管理员',
        contactAdmin: '如有问题可联系管理员',
        invitedBy: '邀请人',
        invitedYouToJoin: '邀请您加入此组织',
        // 订阅状态
        trialing: '试用中',
        subscribed: '已付费',
        pastDue: '待支付',
        canceled: '已取消',
      },
      trialPeriod: '免费试用中',
      trialDaysRemaining: '剩余 {{days}} 天',
      expiresOn: '到期日',
      trialExpired: '试用期已结束',
      upgradeToUnlock: '升级套餐以解锁全部功能',
      // 1.3.93: 试用过期弹窗
      trialExpiredTitle: '免费试用已到期',
      trialExpiredSubtitle: '升级套餐以继续使用',
      trialExpiredMessage: '您的免费试用期已结束。您的项目数据已保存，升级套餐后即可继续使用所有功能。',
      trialExpiredRestrictions: '当前限制：',
      trialExpiredNoCreate: '无法创建新项目',
      trialExpiredNoAccess: '无法访问已有项目',
      trialExpiredDataSafe: '项目数据安全保存',
      upgradeNow: '立即升级',
      // 1.3.98: 配额超限弹窗
      storageExceededTitle: '存储空间已满',
      storageExceededSubtitle: '请删除部分文档或升级套餐',
      storageExceededMessage: '您的存储空间已达到上限，无法上传新文档。请删除一些不需要的文档或升级套餐以获得更多存储空间。',
      storageExceededBanner: '存储空间已满',
      storageExceededHint: '请删除部分文档或升级套餐以继续上传',
      storageNoUpload: '无法上传新文档',
      storageExistingOk: '已有文档正常使用',
      storageDeleteOrUpgrade: '删除文档或升级套餐解除限制',
      currentStorageUsage: '当前存储',
      publicLinkExceededTitle: '公开访问次数已达上限',
      publicLinkExceededSubtitle: '本月配额已用完',
      publicLinkExceededMessage: '您的公开链接访问次数已达到本月上限。升级套餐可获得更多访问配额，或等待下月配额重置。',
      publicLinkExceededBanner: '本月公开访问次数已达上限',
      publicLinkExceededHint: '公开链接暂时无法回复问题，请升级套餐或等待下月重置',
      publicLinkExceededDisabled: '本月公开访问次数已达上限，暂时无法回复问题',
      publicLinkNoAccess: '公开链接暂时无法访问',
      publicLinkInternalOk: '内部对话功能正常',
      publicLinkResetNextMonth: '下月1日配额自动重置',
      currentPublicLinkUsage: '本月访问',
      currentRestrictions: '当前限制：',
      quotaExceeded: '已超出配额限制',
      quotaExceededPlaceholder: '配额已达上限，暂时无法发送消息',
      understood: '我知道了',
      deleteHint: '提示：您可以在项目详情中删除不需要的文档来释放存储空间。',
      subscriptionActive: '订阅已激活',
      // 1.6.57: CRM 内部账号/管理员覆盖
      internalAccount: '内部账号',
      internalAccountDesc: '此账号由管理员设置为内部账号，享受完整功能',
      adminOverride: '管理员授权',
      adminOverrideDesc: '订阅状态由管理员手动设置',
      validUntil: '有效期至',
      currentPeriod: '当前周期',
      cancelAtPeriodEnd: '将在周期结束后取消',
      paymentPastDue: '支付失败',
      updatePaymentMethod: '请更新支付方式以继续使用服务',
      maxMembers: '成员上限',
      purchasedSeats: '已购买席位',
      storage: '存储空间',
      publicLinkQuota: '公开访问/月',
      // 1.3.97: 使用量统计
      storageUsage: '用量统计',
      publicVisits: '访问次数统计',
      upgradePlan: '升级套餐',
      upgradeToBusiness: '升级到 Standard',
      manageSubscription: '管理订阅',
      // 订阅状态标签
      subscriptionStatusNone: '未订阅',
      subscriptionStatusTrialing: '试用中',
      subscriptionStatusActive: '已订阅',
      subscriptionStatusPastDue: '待支付',
      subscriptionStatusCanceled: '已取消',
      // 套餐配置
      planFree: 'Free',
      planIndividual: 'Individual',
      planStandard: 'Standard',
      planFreeDesc: '免费试用，体验核心功能',
      planIndividualDesc: '适合个人用户或自由职业者',
      planStandardDesc: '适合小型团队协作',
      planFeatureTrial7Days: '7天免费试用',
      planFeatureBasicChat: '基础对话功能',
      planFeature1KB: '1个知识库',
      planFeatureNoPublicLink: '无公开链接',
      planFeature1Person: '1人使用',
      planFeature1GBStorage: '1GB 存储空间',
      planFeature5000PublicLinks: '5,000次/月 公开链接访问',
      planFeatureUnlimitedChat: '无限内部对话',
      planFeatureAllBasicFeatures: '所有基础功能',
      planFeature2to50People: '2-50人团队',
      planFeature10GBStorage: '10GB 存储空间',
      planFeature10000PublicLinks: '10,000次/月 公开链接访问',
      planFeatureSharedKB: '共享知识库',
      planFeatureMemberManagement: '成员管理',
      perMonth: '/月',
      perPersonPerMonth: '/人/月',
      // 套餐升级页面
      choosePlanDescription: '选择适合您的套餐，解锁更多功能',
      currentPlan: '当前套餐',
      pleaseSelectPlan: '请选择套餐',
      standardPriceNote: 'Standard 套餐按人数计费，最低 2 人起',
      paymentNote: '您将被重定向到 Stripe 安全支付页面完成支付。支持信用卡、借记卡等多种支付方式。订阅后可随时在账户中心管理或取消。',
      paymentSuccess: '支付成功！订阅已激活。',
      recommended: '推荐',
      selectMemberCount: '选择团队人数',
      people: '人',
      orderSummary: '订单摘要',
      orderSummaryIndividual: 'Individual 套餐 × 1',
      orderSummaryStandard: 'Standard 套餐 × {{count}} 人',
      monthlyTotal: '每月合计',
      processing: '处理中...',
      proceedToPayment: '前往支付',
      securePayment: '安全支付',
      upgradeError: '升级失败，请稍后重试',
      subscriptionActivated: '您的订阅已激活，现在可以使用全部功能了。',
      // 1.3.81: 升级账号（根据状态变化的按钮文字）
      upgradeAccount: '升级账号',
      adjustSeatsDescription: '增加或减少团队席位数量',
      resubscribe: '重新订阅',
      subscriptionResumed: '订阅已恢复，将继续自动续费',
      // 1.3.80: 调整人数功能
      adjustSeats: '调整人数',
      adjustTeamSize: '调整团队人数',
      currentSeats: '当前人数',
      seats: '人',
      increaseSeatsMessage: '增加 {{count}} 个席位，将立即按比例收费约 {{price}}',
      decreaseSeatsMessage: '减少 {{count}} 个席位，将从下个计费周期开始生效',
      proratedBilling: '按当前计费周期剩余天数按比例计算',
      newMonthlyFee: '调整后月费',
      // 1.5.2: 成员配额提示
      memberQuota: '成员配额',
      seatsUsed: '席位已使用',
      quotaFull: '成员配额用尽，如要追加用户，请额外购买席位',
      quotaAlmostFull: '配额即将用尽，请考虑升级套餐',
      // 1.5.5: 邀请按钮禁用提示
      quotaFullCannotInvite: '席位已满，无法邀请新成员',
      quotaFullInviteDisabled: '席位已满，请先调整人数或移除成员后再邀请',
      minSeatsInfo: '最少需要 {{count}} 个席位（当前成员数）',
      
      // 1.5.8: 成员管理相关
      loadFailed: '加载失败',
      memberRemoved: '成员已移除',
      roleUpdated: '角色已更新',
      invitationCanceled: '邀请已取消',
      memberList: '成员列表',
      pendingInvitations: '待处理邀请',
      noMembers: '暂无成员',
      generateInviteLink: '生成邀请链接',
      inviteMember: '邀请成员',
      inviteLink: '邀请链接',
      expiresAt: '过期时间',
      usageCount: '使用次数',
      pending: '待接受',
      cancelInvitation: '取消邀请',
      confirmCancelInvitation: '确定要取消这个邀请吗？',
      removeMember: '移除成员',
      confirmRemoveMember: '确定要移除成员 {{email}} 吗？',
      you: '你',
      joinedAt: '加入于',
      changeToMember: '设为普通成员',
      changeToOwner: '设为管理员',
      inviteSent: '邀请已发送',
      // 邀请成员弹窗
      pleaseEnterEmail: '请输入邮箱地址',
      invalidEmailFormat: '邮箱格式不正确',
      createInviteFailed: '创建邀请失败',
      emailSendFailed: '邮件发送失败，请手动发送邀请链接',
      inviteFailed: '邀请失败',
      inviteMemberDesc: '向团队成员发送邀请邮件',
      emailAddress: '邮箱地址',
      selectRole: '成员角色',
      ownerDesc: '可管理成员',
      memberDesc: '普通成员',
      inviteHint: '邀请邮件将发送至指定邮箱，有效期 7 天',
      sending: '发送中...',
      sendInvite: '发送邀请',
      inviteCreated: '邀请已创建',
      inviteCreatedDesc: '邀请链接已创建，请手动发送给对方',
      inviteSentDesc: '邀请邮件已发送至',
      copied: '已复制',
      copy: '复制',
      inviteNextSteps: '被邀请者收到邮件后，点击链接即可加入组织。链接有效期 7 天。',
      done: '完成',
      // 基本信息标签页
      pleaseLogin: '请先登录',
      basicInfo: '基本信息',
      displayName: '显示名称',
      pleaseEnterName: '请输入显示名称',
      saving: '保存中...',
      save: '保存',
      emailCannotBeChanged: '邮箱地址不可修改',
      loginMethod: '登录方式',
      thirdPartyLoginNote: '使用第三方账号登录，无法修改密码',
      changePassword: '修改密码',
      newPassword: '新密码',
      pleaseEnterNewPassword: '请输入新密码',
      confirmPassword: '确认密码',
      pleaseConfirmPassword: '请再次输入密码',
      updating: '更新中...',
      updatePassword: '修改密码',
      updateProfileFailed: '更新失败',
      updateProfileSuccess: '更新成功',
      passwordMismatch: '两次输入的密码不一致',
      updatePasswordFailed: '密码修改失败',
      updatePasswordSuccess: '密码修改成功',
      // 账号中心页面
      accountCenter: '账号中心',
      accountCenterDescription: '管理您的个人信息和账号设置',
      paymentCanceled: '支付已取消。',
      cancel: '取消',
      confirm: '确认',
      
      // TopNav
      cloudDocuments: '云文档',
      qaChat: 'QA问答',
      synonymLibrary: '同义词库',
      confusingWords: '易混淆词',
      startConversation: '开始对话',
      
      // Auth Modal & Auth Page
      login: '登录',
      signup: '注册',
      email: '邮箱',
      password: '密码',
      or: '或',
      signInWithGoogle: '使用 Google 登录',
      noAccount: '还没有账号？注册',
      hasAccount: '已有账号？登录',
      operationFailed: '操作失败，请重试',
      googleSignInFailed: 'Google登录失败，请重试',
      uiPreviewMode: 'UI 预览模式：登录功能需要配置 Supabase。请参考 docs/DEPLOYMENT.md 进行配置。',
      uiPreviewModeGoogle: 'UI 预览模式：Google 登录功能需要配置 Supabase。请参考 docs/DEPLOYMENT.md 进行配置。',
      welcomeToYUIChat: '欢迎使用 YUIChat',
      enterpriseKnowledgeBaseService: '企业知识库服务',
      aiPoweredQA: 'AI 智能问答',
      multiFileSupport: '多格式文件支持',
      teamCollaboration: '团队协作',
      welcomeBack: '欢迎回来',
      createAccount: '创建账号',
      loginToYourAccount: '登录您的账号',
      signupToGetStarted: '注册开始使用',
      passwordRequirement: '密码至少8位，须包含字母、数字和特殊符号',
      passwordRules: {
        length: '至少8个字符',
        letter: '包含字母',
        digit: '包含数字',
        special: '包含特殊符号（如 !@#$%）',
      },
      verifyYourEmail: '验证您的邮箱',
      verificationEmailSent: '我们已向以下邮箱发送验证链接：',
      checkYourInbox: '请检查您的收件箱并点击验证链接以激活您的账号。',
      backToLogin: '返回登录',
      forgotPassword: '忘记密码？',
      forgotPasswordDescription: '输入邮箱后我们会发送重置密码邮件',
      sendResetEmail: '发送重置邮件',
      resetEmailSent: '重置密码邮件已发送，请查收邮箱',
      resetYourPassword: '重置密码',
      resetPasswordDescription: '请输入新密码完成重置',
      resetPassword: '重置密码',
      passwordResetSuccess: '密码重置成功，请使用新密码登录',
      // 1.3.86: 邮件确认成功提示
      emailConfirmed: '邮箱验证成功！',
      pleaseLoginNow: '请使用您的邮箱和密码登录',
      processingConfirmation: '正在处理邮箱验证...',
      
      // Chat Interface
      references: '参考资料：',
      page: '页',
      sendMessageFailed: '发送消息失败',
      aiThinking: 'AI正在思考中', // 1.2.27
      
      // Knowledge Base Page
      noData: '暂无数据',
      fileNameOrUrl: '文件名/网址',
      type: '类型',
      fileSize: '文件大小',
      wordCount: '字数',
      status: '状态',
      uploadTime: '上传时间',
      action: '操作',
      relearn: '重新学习',
      confirmDelete: '确定要删除这个文档吗？',
      confirmDeleteTitle: '您确定要删除选中的文档？', // 1.1.14: 确认删除弹窗标题
      confirmBatchDelete: '确定要删除选中的 {{count}} 个文档吗？',
      confirmBatchDeleteTitle: '您确定要删除选中的文档？', // 1.1.14: 批量确认删除弹窗标题
      confirm: '确认', // 1.1.14: 确认按钮文本
      batchReload: '批量重新加载',
      batchDelete: '批量删除',
      deleting: '删除中...',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      noPermissionToDelete: '没有权限删除这些内容', // 1.5.0
      reloading: '重新加载中...',
      reloadStarted: '重新加载已开始',
      reloadFailed: '重新加载失败',
      fileReloadNotSupported: '文件类型文档暂不支持重新加载，请重新上传',
      uiPreviewUpload: 'UI 预览模式：文件上传功能需要配置 Supabase 和 Dify。\n\n请参考 docs/DEPLOYMENT.md 进行配置。',
      analyzing: '分析中...',
      saving: '保存中...',
      websiteLink: '网站链接',
      enterWebsiteUrl: '在此处输入网站URL:',
      websiteUrlPlaceholder: '请输入URL (键入回车或右侧"+"添加,支持批量)',
      websiteUrlHint: 'URL需要以 https:// 或 http:// 开头',
      urlDuplicateError: '此URL已存在,请勿重复添加',
      urlFormatError: 'URL 格式不符合',
      add: '添加',
      remove: '删除',
      
      // Create Project Modal
      knowledgeBaseName: '知识库名称',
      knowledgeBaseNamePlaceholder: '例如 智能客服助手、产品问答机器人',
      description: '描述说明',
      descriptionPlaceholder: '请输入关键描述内容...',
      oneClickGenerate: '一键生成',
      roleSelectionHint: '角色选定后不能切换哦~',
      create: '创建',
      creating: '创建中...',
      generatedDescriptionPlaceholder: 'AI生成的描述内容...',
      exampleDocument: '示例文档.pdf',
      productManual: '产品手册.docx',
      
      // Language Switcher
      switchLanguage: '切换语言',
      
      // 1.2.26: Conversation History
      conversationHistory: '对话记录',
      newConversation: '新增对话',
      noConversations: '暂无对话记录',
      deleteConversation: '删除对话',
      deleteConversationConfirm: '确定要删除这个对话吗？此操作不可恢复。',
      collapseConversations: '收起',
      loadConversationsFailed: '加载对话记录失败',
      createConversationFailed: '创建新对话失败',
      loadConversationFailed: '加载对话失败',
      deleteConversationSuccess: '删除成功',
      deleteConversationFailed: '删除失败',
      pleaseSelectProject: '请先选择项目',
      pleaseLogin: '请先登录',
      
      // Share Page
      shareDescription: '生成一个公开的聊天链接，让您的用户直接与 AI 助手对话。',
      shareLinkSettings: '分享链接设置',
      active: '活跃',
      publicAccessLink: '公开访问链接（项目级别）',
      linkCopied: '链接已复制到剪贴板',
      tokenRefreshed: '分享令牌已刷新',
      refreshFailed: '刷新失败',
      noKnowledgeBase: '未找到项目',
      pleaseCreateKBFirst: '请先创建一个项目以开启分享功能。',
      copy: '复制',
      copied: '已复制',
      visit: '访问',
      regenerateLink: '重置链接',
      regenerateLinkTip: '如果您担心链接泄露，可以重置令牌。旧链接将立即失效。',
      resetLink: '重置分享链接',
      shareModeInstructions: '使用说明',
      shareInstruction1: '该链接直接打开您的专属对话界面。',
      shareInstruction2: '用户无需登录即可进行基于项目所有文档的问答。',
      shareInstruction3: '所有对话数据将归档在"对话数据"中。',
      securityNotice: '安全提示',
      securityNoticeText: '请妥善保管您的分享链接。虽然用户无法修改您的项目，但他们可以访问项目中所有文档的公开信息。',
      
      // 1.2.28: Public Chat Page
      publicChatLoading: '加载中...',
      publicChatAccessFailed: '访问失败',
      publicChatInvalidLink: '该分享链接无效或已失效',
      publicChatContactOwner: '请联系分享者获取新的链接，或检查链接是否完整。',
      publicChatAiAssistant: 'AI 助手',
      
      // 1.2.28: Default Questions
      defaultQuestion1: '您能介绍一下这个项目吗？',
      defaultQuestion2: '有哪些常见问题？',
      defaultQuestion3: '如何使用这个系统？',
      aiGeneratedDisclaimer: '以上内容由AI生成，不代表开发者立场',
      
      // 1.2.52: Test Chat Interface
      internalTestInterface: '这是内部测试界面。',
      newChat: '新建对话',
      openPublicSharePage: '打开公开分享页面',
      
      // Project Settings Page
      projectSettingsDescription: '管理项目的基本信息',
      tabProjectInfo: '项目信息',
      tabDigitalEmployee: '数字员工',
      tabConversation: '对话设置',
      tabSkills: '技能设置',
      modifyProjectInfo: '修改项目名称和描述',
      projectName: '项目名称',
      projectNamePlaceholder: '请输入项目名称',
      projectDescription: '项目描述',
      projectDescriptionPlaceholder: '请输入项目描述',
      digitalEmployeeConfig: '配置数字员工的基本信息和形象',
      digitalEmployeeDeveloping: '数字员工配置功能开发中...',
      conversationConfig: '配置AI头像、欢迎语和推荐问题',
      // 1.3.18: 性能模式选择
      performanceMode: '性能模式',
      performanceModeHint: '选择AI回复的性能模式',
      fastMode: '快速模式',
      fastModeDesc: '响应时间1-2秒，适合实体机器人、电话等需要实时响应的场景',
      accurateMode: '精准模式',
      accurateModeDesc: '响应时间3-7秒，适合文字类客服，大模型通过深度思考得出更准确的结论',
      betaTag: 'Beta',
      aiAvatar: 'AI头像',
      clickOrDragUpload: '点击或拖拽图片到此处上传',
      avatarUploadHint: '支持 PNG、JPG、JPEG、GIF、WEBP，最大2MB',
      welcomeMessageMultiLang: '欢迎语（多语言）',
      recommendedQuestionsMultiLang: '推荐问题（多语言，最多3个）',
      addQuestion: '添加问题',
      questionIndex: '问题 {{index}}',
      saveConfig: '保存配置',
      skillsConfig: '配置AI的技能和能力',
      skillsDeveloping: '技能设置功能开发中...',
      projectNotFound: '项目不存在',
      pleaseCreateProjectFirst: '请先创建一个项目',
      projectAccessDenied: '项目不存在或无权访问',
      invalidImageType: '请上传图片文件（png, jpg, jpeg, gif, webp）',
      imageSizeTooLarge: '头像文件大小不能超过2MB',
      invalidImageFile: '请上传有效的图片文件（不超过2MB）',
      maxQuestionsReached: '每种语言最多只能添加3个推荐问题',
      settingsSaved: '设置已保存',
      settingsSaveFailed: '保存失败，请重试',
      // 1.3.16: 自动翻译填充功能
      autoFillOtherLangs: '自动填充其他语言',
      autoFillHint: '输入任意一种语言的欢迎语后，点击"自动填充其他语言"按钮可自动翻译填充其他语言',
      autoFillQuestionsHint: '输入任意一种语言的推荐问题后，点击"自动填充其他语言"按钮可自动翻译填充其他语言',
      autoFillSuccess: '自动填充成功',
      autoFillFailed: '自动填充失败，请重试',
      noSourceTextToTranslate: '请先输入内容',
      
      // 1.2.54: 删除项目功能
      deleteProject: '删除项目',
      deleteProjectConfirmTitle: '确认删除项目',
      deleteProjectConfirmDescription: '此操作将永久删除项目「{{projectName}}」及其所有文档和对话记录。此操作不可恢复，是否继续？',
      deleteProjectSuccess: '项目删除成功',
      deleteProjectFailed: '项目删除失败',
      
      // 1.4.4: 知识库共享功能
      shareWithOrganization: '共享给组织成员',
      shareWithOrganizationDesc: '开启后，组织内所有成员可访问此知识库',
      sharingEnabled: '已开启共享',
      sharingDisabled: '已关闭共享',
      toggleSharingFailed: '更新共享状态失败',

      // 1.2.55: 空知识库提示
      emptyKnowledgeBaseMessage: '还没有上传任何知识～请立即前往知识库上传吧',
      goToKnowledgeBase: '立即前往',
      emptyKnowledgeBasePlaceholder: '请先上传知识库文档',
      
      // 1.3.0: follow_up 推荐问题
      followUpQuestions: '您可能还想问：',
      
      // 1.3.11: 引用来源展示
      citationSources: '引用来源',
      documentSource: '文档：来源于{{count}}个文档', // 1.6.8: ChatMax 风格引用来源文案
      relevanceScore: '相关度',
      viewSource: '查看来源',
      citationNote: '显示相关度最高的文档片段',
      paragraph: '段落', // 1.6.14: 引用段落
      paragraphCount: '{{count}} 个段落', // 1.6.14: 段落数量
      
      // 1.3.19: 引用来源显示配置
      citationDisplaySettings: '引用来源显示设置',
      citationDisplaySettingsHint: '配置C端聊天窗口中引用来源的显示方式，管理端的测试对话永远显示引用来源',
      showCitation: '显示引用来源',
      showCitationDesc: '在AI回复中显示引用来源链接，并可在右侧面板查看详细引用内容',
      
      // 1.3.7: 知识库Banner 4步流程
      bannerTitle4Steps: '4步快速创建客服应用', // 1.6.28: 修改标题
      bannerSubtitle4Steps: '上传文件，网站URL',
      stepUploadDoc: '点击立即创建上传文档', // 1.6.28: 修改步骤说明
      stepWaitLearning: '等待学习完成',
      stepTestChat: '点击AI对话确认对话质量', // 1.6.28: 修改步骤说明
      stepShareLink: '点击外部分享公开客服应用', // 1.6.28: 修改步骤说明
      
      // 1.3.14: 对话统计和数据管理
      projectStats: '项目统计',
      documentStats: '文档统计',
      totalDocuments: '总文档数',
      completed: '已完成',
      processingDocs: '处理中',
      failed: '失败',
      conversationStats: '对话统计',
      totalConversations: '总对话数',
      testLabel: '测试',
      publicLabel: '外部',
      testConversationLabel: '测试对话',
      realConversationLabel: '真实对话',
      todayConversations: '今日对话',
      totalMessages: '总消息数',
      frequentQuestionsCount: '高频问题数',
      completionRate: '处理完成率',
      frequentQuestions: '高频问题',
      noFrequentQuestions: '暂无高频问题',
      times: '次',
      projectNotExist: '项目不存在',
      pleaseCreateProject: '请先创建一个项目',
      
      // 对话数据页面
      selectDate: '选择日期',
      allSources: '全部来源',
      testConversations: '测试对话',
      publicConversations: '外部对话',
      searchPlaceholder: '搜索对话内容...',
      search: '查询',
      source: '来源',
      firstQuestion: '首条提问',
      lastResponse: '最后回复',
      messages: '消息',
      time: '时间',
      actions: '操作',
      noMessages: '暂无消息',
      retentionSettings: '数据保存设置',
      dataRetentionPeriod: '数据保存周期',
      retentionPermanent: '永久',
      retention3Months: '3个月',
      retention6Months: '6个月',
      retention1Year: '1年',
      settings: '设置',
      
      // 1.3.30: QA问答管理
      qaManagement: 'QA问答管理',
      qaManagementDesc: '管理问答对，支持单个创建和批量上传',
      qaList: '问答对',
      uploadRecords: '上传记录',
      createQA: '新建问答',
      editQA: '编辑问答',
      batchUploadQA: '批量上传问答',
      searchQuestion: '搜索问题',
      question: '问题',
      answer: '答案',
      userQuestion: '用户问题',
      replyAnswer: '回复答案',
      similarQuestions: '相似问题',
      inputQuestion: '请输入用户问题',
      inputAnswer: '请输入回复答案',
      inputSimilarQuestion: '请输入相似问题',
      addSimilarQuestion: '增加相似问题',
      questionRequired: '请输入用户问题',
      answerRequired: '请输入回复答案',
      answerHint: '支持富文本格式，可以包含链接、图片等',
      selectProject: '请先选择项目',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      statusPending: '待学习',
      statusLearned: '学习成功',
      statusFailed2: '学习失败',
      sourceCustom: '自定义编辑',
      sourceBatch: '批量上传',
      updateTime: '更新时间',
      allLearned: '全部已学习',
      noQAData: '暂无问答数据',
      createFirstQA: '创建第一个问答',
      confirmDeleteQA: '确定要删除这个问答吗？',
      selectedCount: '已选择 {{count}} 项',
      paginationInfo: '显示 {{start}}-{{end}} 条，共 {{total}} 条',
      prevPage: '上一页',
      nextPage: '下一页',
      // 批量上传弹窗
      templateDownloadHint: '请按照模板格式填写问答数据，然后上传xlsx文件。',
      downloadTemplate: '下载模板',
      multipleQuestionsHint: '如果有多个问题对应同一答案，使用"|"隔开',
      uploadDocument: '点击或拖拽文件到此处上传',
      uploadHint: '支持xlsx格式，最大20MB',
      onlyXlsxSupported: '仅支持xlsx格式文件',
      fileTooLarge: '文件大小超过20MB限制',
      selectFile: '请选择文件',
      removeFile: '移除文件',
      uploadComplete: '上传完成',
      totalRecords: '总条目数',
      successRecords: '成功导入',
      failedRecords: '导入失败',
      parseErrors: '解析错误',
      andMore: '还有 {{count}} 条...',
      noUploadRecords: '暂无上传记录',
      filename: '文件名',
      totalCount: '总条目',
      successCount: '成功数',
      failedCount: '失败数',
      
      // 1.3.78: Onboarding 页面
      onboarding: {
        welcomeTitle: '欢迎使用 YuiChat',
        selectScenario: '请选择您的使用场景',
        personalUser: '个人用户',
        personalUserDesc: '适合个人学习、研究使用',
        businessUser: '企业用户',
        businessUserDesc: '适合团队协作、企业级应用',
        // 定价相关
        individualUsers: '1人',
        standardUsers: '2~50人',
        perPersonMonth: '人/月',
        free7Days: '7天免费试用',
        popular: '推荐',
        unlimitedChat: '内部对话无限',
        publicLink5000: '公开链接配额 5,000次/月',
        publicLink10000: '公开链接配额 10,000次/月',
        unlimitedKB: '知识库项目数无限',
        storage1GBPerson: '存储空间 1GB/人',
        storage10GB: '存储空间 10GB',
        multiUser: '多用户账号',
        sharedKB: '共享知识库',
        rolePermissions: 'Owner/Member 角色权限',
        overageNote: '超额后暂停公开访问，下月重置',
        // 旧翻译保留兼容
        storage1GB: '1GB 存储空间',
        multiMember: '多成员协作',
        unlimitedKBShared: '无限知识库 + 共享',
        select: '选择',
        upgradeAnytime: '随时可从「设置」升级为企业用户',
        successTitle: '注册成功！',
        successDesc: '您已成功注册为个人用户',
        tipTitle: '温馨提示',
        tipContent: '如果您后续需要团队协作或更多企业级功能，可以随时在「设置 > 账户」中升级为企业用户，所有数据将完整保留。',
        startUsing: '开始使用 YuiChat',
        createFailed: '创建失败，请重试',
        backToLogin: '返回登录',
      },
      // 1.4.2: 邀请页面
      invite: {
        joinOrganization: '加入组织',
        invitedToJoin: '您被邀请加入',
        roleLabel: '角色',
        roleMember: '成员',
        roleOwner: '所有者',
        roleJoin: '身份加入',
        willJoinAs: '您将以',
        currentAccount: '当前账号',
        inviteExpiresAt: '邀请有效期至',
        decline: '拒绝',
        acceptInvite: '接受邀请',
        loginToAcceptInvite: '登录或注册以接受邀请',
        loginTab: '登录',
        registerTab: '注册',
        continueWithGoogle: '使用 Google 登录',
        signUpWithGoogle: '使用 Google 注册',
        or: '或',
        email: '邮箱',
        enterEmail: '请输入邮箱',
        password: '密码',
        enterPassword: '请输入密码',
        setPassword: '设置密码（至少8位，含字母+数字+符号）',
        loginAndJoin: '登录并加入',
        registerAndJoin: '注册并加入',
        verifyingInvite: '正在验证邀请...',
        inviteInvalid: '邀请链接无效',
        invalidInviteLink: '无效的邀请链接',
        inviteExpired: '邀请链接已过期或无效',
        backToHome: '返回首页',
        joinedOrganization: '已成功加入组织',
        acceptFailed: '加入失败',
        checkEmailForConfirmation: '请检查邮箱完成验证',
        // 1.5.6: 多窗口场景翻译
        alreadyJoined: '已成功加入组织',
        alreadyJoinedDesc: '您已通过其他窗口成功加入组织',
        joinedAs: '您的角色',
        closeTabHint: '您可以关闭此窗口，在另一个窗口中继续使用',
        confirmAndClose: '确认',
      },
      // 1.3.81: 注册页面
      register: {
        welcomeTitle: '创建您的 YuiChat 账号',
        selectUserType: '请选择您的使用场景',
        personalRegisterTitle: '个人用户注册',
        personalRegisterSubtitle: '输入邮箱和密码创建您的个人账号',
        businessRegisterTitle: '企业用户注册',
        businessRegisterSubtitle: '填写企业信息并创建管理员账号',
        businessInfoSection: '企业信息',
        accountInfoSection: '账号信息',
        emailRequired: '请输入邮箱地址',
        passwordRequired: '请输入密码',
        registering: '注册中...',
        registerAndVerify: '注册并发送验证邮件',
        alreadyHaveAccount: '已有账号？',
        businessInfoSaved: '企业信息已保存',
        businessInfoSavedDesc: '验证邮箱后，将自动为「{{companyName}}」创建企业账号，您将成为该企业的管理员。',
      },
      // 1.3.78: 企业信息页面
      businessSetup: {
        back: '返回',
        backToLogin: '返回登录',
        title: '完善企业信息',
        subtitle: '请填写以下信息以创建您的企业账户',
        companyName: '企业名称',
        companyNamePlaceholder: '请输入企业名称',
        companyNameRequired: '请输入企业名称',
        companySize: '企业规模',
        companySizeRequired: '请选择企业规模',
        size1to5: '2-5 人',
        size6to20: '6-20 人',
        size21to50: '21-50 人',
        size51plus: '51+ 人',
        industry: '行业',
        industryPlaceholder: '请选择行业',
        industryTech: '科技/互联网',
        industryFinance: '金融/银行',
        industryHealthcare: '医疗/健康',
        industryEducation: '教育/培训',
        industryManufacturing: '制造业',
        industryRetail: '零售/电商',
        industryConsulting: '咨询/服务',
        industryMedia: '媒体/传播',
        industryGovernment: '政府/公共服务',
        industryOther: '其他',
        jobTitle: '您的职位',
        jobTitlePlaceholder: '如：产品经理、技术负责人',
        optional: '选填',
        completeRegistration: '完成注册',
        creating: '创建中...',
        createFailed: '创建失败，请重试',
        adminNote: '创建后，您将成为该企业的管理员，可以邀请团队成员加入',
      },
      // 1.3.40: 落地页
      landing: {
        // 导航
        navProblem: '痛点',
        navSolution: '解决方案',
        navROI: '投资回报',
        navFeatures: '功能',
        navCases: '案例',
        navPricing: '定价',
        freeTrial: '免费试用',
        
        // Hero
        heroTitle: '让员工问题，1秒得到答案',
        heroTitleHtml: '让员工问题，<span class="highlight">1秒</span>得到答案',
        heroSubtitle: '减少50%重复咨询 · 节省300万年度成本',
        heroSubtitleHtml: '重复咨询 <span class="number">50%</span> 削减<span class="divider">|</span>年度成本 <span class="number">¥300万</span> 节省',
        featureInstant: '即时响应',
        featureInstantDesc: '等待时间归零',
        featureCost: '成本削减',
        featureCostDesc: '年省240万起',
        featureSecurity: '安全可控',
        featureSecurityDesc: '数据完全隔离',
        // 价值卡片
        valueSpeed: '压倒性的速度',
        valueSpeedDesc: '等待时间归零。最大化员工生产力，业务不中断。',
        valueCost: '管理成本削减',
        valueCostDesc: '后台负担减半。为核心业务集中资源。',
        valueEasy: '人人可用的简便性',
        valueEasyDesc: '无需IT技能。无需手册，今天就能使用。',
        tryFree7Days: '免费试用7天',
        bookDemo: '预约演示',
        servedCompanies: '已服务 500+ 家企业',
        
        // Problem Section
        problemTitle: '您的企业是否面临这些挑战？',
        problemSubtitle: '平均每个员工每天浪费1.8个小时寻找信息，是时候改变了',
        problemStat1Label: '业务时间的浪费',
        problemStat2Label: '平均等待时间',
        problemStat3Label: '1日的检索时间',
        problem1Title: '人力成本高涨',
        problem1Desc: '客服、HR、IT部门每天重复回答相同问题，专业人员时间浪费在低价值工作上，人力成本居高不下。',
        problem2Title: '响应速度慢',
        problem2Desc: '员工提问后平均等待2-4小时才能得到答案，工作被迫中断，业务流程效率低下。',
        problem3Title: '知识分散混乱',
        problem3Desc: '文档散落在各个系统和文件夹中，员工找不到、找不准、找不全，信息孤岛严重。',
        
        // Solution Section
        solutionTitle: '一个简单的解决方案',
        solutionHeadline: '上传文件，员工就能自己找答案',
        solutionHeadlineHtml: '上传文件，<br/>员工<span class="highlight">自己找到答案</span>的世界',
        pillar1Title: '省钱',
        pillar1Desc: '减少50%重复咨询\n人力成本大幅下降',
        pillar2Title: '省时',
        pillar2Desc: '1秒得到答案\n工作流程不中断',
        pillar3Title: '省心',
        pillar3Desc: '24小时自动服务\n无需人工值守',
        // Solution Cards
        solution1Title: '成本削减',
        solution1DescHtml: '减少重复咨询<br/><span class="number">50%</span> 削减',
        solution2Title: '时间缩短',
        solution2DescHtml: '等待时间归零<br/><span class="number">1秒</span> 获得答案',
        solution3Title: '无压力',
        solution3DescHtml: '无需担心负责人不在<br/><span class="number">24小时</span> 自动应答',
        noCode: '无需编程 · 无需培训 · 3分钟完成部署',
        
        // ROI Section
        roiTitle: '看得见的投资回报',
        roiSubtitle: '投入1.5万/月，年省240万 - 基于500人规模企业测算',
        roiRate: '投资回报率',
        roiRateDesc: '行业领先水平',
        paybackPeriod: '投资回收期',
        paybackPeriodDesc: '快速回本',
        annualSaving: '年度节省',
        annualSavingDesc: '持续降低成本',
        efficiencyUp: '效率提升',
        efficiencyUpDesc: '业务加速增长',
        days: '天',
        tenThousand: '万元',
        
        // Comparison Section
        comparisonTitle: '看得见的投资回报',
        comparisonSubtitle: '传统方式 vs YUIChat',
        traditionalMethod: '传统人工方式',
        traditionalMethodDesc: '客服、HR、IT团队重复回答相同问题，人力成本居高不下',
        yuichatMethodDesc: 'AI智能问答7×24小时自动响应，大幅降低人工成本',
        annualLaborCost: '年度人力成本',
        annualSystemCost: '年度系统成本',
        annualSave: '年度节省',
        
        // Steps Section
        stepsTitle: '3步开始使用，零技术门槛',
        stepsSubtitle: '简单到不可思议，却强大到超乎想象',
        step1Title: '上传文件',
        step1Desc: '拖拽即可，支持PDF、Word、Excel、PPT、网页等多种格式，系统自动解析学习。',
        step2Title: '员工提问',
        step2Desc: '像聊天一样简单，用自然语言提问，无需记住关键词，AI理解问题意图。',
        step3Title: '立即得到答案',
        step3Desc: '1秒内响应，精准回答并自动引用来源，可追溯，可信赖。',
        noTraining1: '无需培训',
        noTraining2: '无需技术人员',
        noTraining3: '3分钟完成部署',
        
        // Efficiency Section
        efficiencyTitle: '真实的效率改善数据',
        efficiencySubtitle: '导入前后对比 - 基于真实客户数据',
        efficiency1Title: '首次响应时间',
        efficiency1Before: '导入前: 平均2小时',
        efficiency1Improve: '90%以上缩短',
        efficiency2Title: 'AI自动解决率',
        efficiency2Before: '导入前: 0%（全部手动）',
        efficiency2Improve: '问询激减',
        efficiency3Title: '问题解决速度',
        efficiency3Before: '导入前: 平均5分钟',
        efficiency3Improve: '80%效率化',
        second: '秒',
        minute: '分',
        
        // Cases Section
        casesTitle: '客户成功案例',
        casesSubtitle: '他们已经在使用YUIChat，并获得了显著成效',
        case1Quote: '部署仅用了3天，现在每月节省50小时工时，员工不再为找文档而苦恼。',
        case1Company: '某制造企业',
        case1Scale: '500人规模',
        case1Stat1: '3天部署',
        case1Stat2: '月省50小时',
        case2Quote: '客户满意度从70%提升到92%，支持团队压力大幅减轻，终于有时间做更有价值的工作。',
        case2Company: '某SaaS公司',
        case2Scale: '200人规模',
        case2Stat1: '满意度92%',
        case2Stat2: '响应提速5倍',
        case3Quote: '新员工培训周期缩短60%，入职第一天就能自己找到所需信息，HR工作量大幅降低。',
        case3Company: '某教育机构',
        case3Scale: '培训行业',
        case3Stat1: '培训周期-60%',
        case3Stat2: 'HR效率+80%',
        
        // Features Section
        featuresTitle: '功能强大，但使用简单',
        featuresSubtitle: '企业级功能，消费级体验',
        feature1Title: '多格式支持',
        feature1Desc: 'PDF/Word/Excel/PPT/网页全支持',
        feature2Title: '智能问答',
        feature2Desc: '基于文档内容精准回答',
        feature3Title: '一键分享',
        feature3Desc: '生成外部访问链接',
        feature4Title: '多语言',
        feature4Desc: '中/英/日原生支持',
        feature5Title: '数据统计',
        feature5Desc: '问答记录与分析',
        feature6Title: '安全隔离',
        feature6Desc: '项目级数据隔离',
        feature7Title: '语义缓存',
        feature7Desc: '相似问题<500ms响应',
        feature8Title: '推荐问题',
        feature8Desc: '自动生成常见问题',
        
        // Pricing Section
        pricingTitle: '价格方案',
        pricingSubtitle: '选择适合您的方案',
        pricingTypeIndividual: '个人',
        pricingTypeEnterprise: '企业',
        pricingIndividualUsers: '1人',
        pricingStandardUsers: '2～50人',
        pricingEnterpriseUsers: '51人以上',
        pricingPerPerson: '人/月',
        pricingPerson: '人',
        pricingContactUs: '联系我们',
        pricingUnlimitedChat: '内部对话无限',
        pricingPublicLink: '公开链接配额',
        pricingTimesMonth: '次/月',
        pricingTimesPersonMonth: '次/人/月',
        pricingUnlimitedKB: '知识库项目数无限',
        pricingStorage: '存储空间',
        pricingCustom: '自定义',
        pricingPopular: '推荐',
        pricingMultiUser: '多用户账号',
        pricingSharedKB: '共享知识库',
        pricingRoleOwnerMember: 'Owner/Member 角色权限',
        pricingAllStandardFeatures: '包含Standard所有功能',
        pricingDedicatedSupport: '专属技术支持',
        pricingFeatureComparison: '功能对比',
        pricingFeature: '功能',
        pricingAccountManagement: '账号管理',
        pricingInviteMembers: '邀请成员',
        pricingKnowledgeBase: '知识库',
        pricingPersonalKB: '个人知识库',
        pricingRolePermission: '角色权限',
        pricingRoleOwner: '所有者',
        pricingRoleMember: '成员',
        pricingOverage: '超额后暂停公开访问，下月重置',
        pricingNote: '所有方案均含7天免费试用 · 可随时升级或降级',
        
        // CTA Section
        ctaTitle: '立即开始，快速回本',
        ctaSubtitle: '企业知识的价值最大化，最聪明的投资',
        ctaLowCost: '压倒性低成本',
        ctaQuickPayback: '快速回收投资',
        ctaSave240: '年省582万',
        ctaCostReduction: '持续削减成本',
        ctaZeroTech: '零技术门槛',
        ctaQuickDeploy: '3分钟部署完成',
        month: '月',
        bookDemoExec: '预约高管演示',
        trustSecurity: '企业级安全认证',
        trustPrivate: '支持私有化部署',
        trustSupport: '7×24小时技术支持',
        
        // Footer
        footerDesc: '企业级AI知识库管理平台\n让企业知识触手可及，通过AI智能问答降低知识获取成本，提升工作效率',
        footerProduct: '产品',
        footerSolution: '解决方案',
        footerFeatures: '功能特性',
        footerCases: '客户案例',
        footerPricing: '价格方案',
        footerResources: '资源',
        footerDocs: '产品文档',
        footerAPI: 'API文档',
        footerBlog: '博客',
        footerHelp: '帮助中心',
        footerContact: '联系我们',
        footerLocation: '日本 · 东京',
        footerPrivacy: '隐私政策',
        footerTerms: '服务条款',
      },
    }
  },
  ja: {
    translation: {
      appTitle: 'YUIChat',
      appSubtitle: '企業ナレッジベースサービス',
      knowledgeBase: 'ナレッジベース管理',
      knowledgeBaseTitle: '企業の知識リソースが多すぎて、複雑すぎますか？',
      knowledgeBaseSubtitle: 'ファイル、オーディオ/ビデオ、ウェブサイト、5秒でナレッジベースを作成',
      createNow: '今すぐ作成',
      createOnlineDoc: 'オンラインドキュメントを作成',
      allDocuments: 'すべてのドキュメント',
      searchFileName: 'ファイル名/URLを検索',
      uploadKnowledgeBase: 'ナレッジベースをアップロード',
      localFiles: 'ローカルファイル',
      supportedFormats: 'サポート形式: txt、pdf、docx、pptx、xlsx',
      dragFilesHere: 'ファイルをここにドラッグするか、',
      selectFiles: 'ファイルを選択',
      maxFileSize: '単一ファイル最大 50 MB',
      maxAudioFileSize: '単一ファイル最大1GB',
      supportsMultipleFiles: '複数ファイルのアップロードをサポート',
      singleFileUploadOnly: '単一ファイルのアップロードのみサポート',
      audioSupportedFormats: 'サポート形式:mp4、mp3、wav',
      selectedFile: '選択されたファイル',
      waitForTraining: 'ファイルアップロード後、トレーニングが「完了」になるまで待つ必要があります',
      maxDocumentChars: 'あなたのプランに応じて、最大 10000 文字のドキュメントに対して質問を生成することができます',
      canCloseDuringUpload: 'アップロード中にこのウィンドウを閉じて他の操作を続けることができます',
      selectedFiles: '選択されたファイル',
      previousStep: '前のステップ',
      autoGenerateQA: '自動的にQ&Aを生成',
      startUpload: 'アップロードを開始',
      uploading: 'アップロード中...',
      uploadSuccess: 'アップロード完了', // 1.6.26
      uploadFailed: 'アップロード失敗', // 1.6.26
      maxFilesLimit: '一度に最大 {{max}} ファイルまでアップロード可能', // 1.6.26
      maxFilesExceeded: 'ファイル数制限を超えました。先頭 {{max}} ファイルのみアップロードされます', // 1.6.26
      urlProcessing: '処理中', // 1.6.27
      urlSuccess: '処理完了', // 1.6.27
      urlFailed: '処理失敗', // 1.6.27
      analyzeAudioVideo: 'オーディオ/ビデオを分析',
      audioVideoSubtitle: '複数のオーディオ/ビデオを字幕ファイルに変換',
      websiteAnalysis: 'ウェブサイト分析',
      websiteAnalysisDesc: 'ウェブサイトリンクを入力し、ウェブサイト情報を分析',
      statusProcessing: '学習中',
      statusCompleted: '学習成功',
      statusFailed: '学習失敗',
      uploadedWaitingProcessing: 'アップロード成功、処理中...',
      chatMode: 'チャット',
      chatWelcomeTitle: 'AI ナレッジベースアシスタント',
      chatWelcomeMessage: 'あなたのナレッジベースに基づいて、質問に答えることができます！',
      chatInputPlaceholder: '質問を教えてください...',
      chatError: 'エラーが発生しました',
      save: '保存',
      cancel: 'キャンセル',
      delete: '削除',
      edit: '編集',
      close: '閉じる',
      loading: '読み込み中...',
      error: 'エラー',
      success: '成功',
      
      // Navigation & Sidebar
      projectSettings: 'プロジェクト設定',
      testChat: 'AIチャット',
      externalShare: '外部共有',
      dashboard: 'データダッシュボード',
      allProjects: 'すべてのプロジェクト',
      createProject: 'プロジェクトを作成',
      exampleProject: 'サンプルプロジェクト',
      conversationData: '会話データ',
      currentProject: '現在のプロジェクト',
      currentOrganization: '現在の組織', // 1.4.6
      selectOrganization: '組織を選択', // 1.4.6
      business: '法人', // 1.4.6
      personal: '個人', // 1.4.6
      owner: 'オーナー', // 1.4.6
      member: 'メンバー', // 1.4.6
      account: 'アカウント',
      user: 'ユーザー',
      signOut: 'ログアウト',
      defaultProject: 'デフォルトプロジェクト',
      accountCenter: 'アカウントセンター', // 1.2.6
      feedback: 'フィードバック', // 1.2.6
      back: '戻る', // 1.2.29
      
      // Account Center Page - 1.2.29
      accountCenterDescription: '個人情報とアカウント設定を管理',
      basicInfo: '基本情報',
      displayName: '表示名',
      pleaseEnterName: '名前を入力してください',
      emailCannotBeChanged: 'メールアドレスは変更できません',
      loginMethod: 'ログイン方法',
      thirdPartyLoginNote: 'サードパーティアカウントでログインしています。パスワードはサービスプロバイダーによって管理されています。パスワードを変更するには、対応するサービスプロバイダーで変更してください。',
      changePassword: 'パスワード変更',
      newPassword: '新しいパスワード',
      pleaseEnterNewPassword: '新しいパスワードを入力してください',
      confirmPassword: 'パスワードの確認',
      pleaseConfirmPassword: '新しいパスワードを再度入力してください',
      updatePassword: 'パスワードを更新',
      updating: '更新中...',
      updateProfileSuccess: 'プロフィール更新成功',
      updateProfileFailed: 'プロフィール更新失敗',
      updatePasswordSuccess: 'パスワード更新成功',
      updatePasswordFailed: 'パスワード更新失敗',
      passwordMismatch: 'パスワードが一致しません',
      
      // Feedback Page - 1.2.29
      feedbackDescription: 'ご意見やご提案をお寄せください',
      note: '注意',
      feedbackNote: 'お客様のフィードバックは私たちにとって非常に重要です。すべてのフィードバックを真剣に読み、製品の改善に努めます。',
      
      // 1.3.85: 認証エラーメッセージ多言語対応
      authErrors: {
        invalidCredentials: 'メールアドレスまたはパスワードが正しくありません',
        emailNotConfirmed: 'メールアドレスが未確認です。確認メールをご確認ください',
        userAlreadyRegistered: 'このメールアドレスは既に登録されています',
        credentialTooShort: 'パスワードは8文字以上で、英字・数字・記号を含む必要があります',
        invalidEmailFormat: 'メールアドレスの形式が正しくありません',
        signupDisabled: '登録機能は現在無効になっています',
        emailRateLimitExceeded: 'メール送信回数の上限に達しました。しばらくしてからお試しください',
        rateLimitExceeded: 'セキュリティ上の理由により、60秒後に再試行してください',
        networkError: 'ネットワーク接続に問題があります。接続を確認して再試行してください',
        serviceUnavailable: 'サービスは一時的に利用できません。しばらくしてから再試行してください',
        invalidOrExpiredResetToken: '再設定リンクが無効か期限切れです',
      },

      // 1.5.3: API/組織関連エラーメッセージ翻訳
      apiErrors: {
        // 招待関連
        invalidInvitationLink: '無効な招待リンクです',
        invitationNoLongerValid: 'この招待は無効になりました',
        invitationExpired: '招待リンクの有効期限が切れています',
        invitationMaxUsage: 'この招待リンクは使用回数の上限に達しました',
        invitationWrongEmail: 'この招待リンクは特定のメールアドレス専用です',
        alreadyMember: 'すでにこの組織のメンバーです',
        organizationMaxMembers: 'この組織はメンバー数の上限に達しました',
        userAlreadyMember: 'このユーザーはすでにメンバーです',
        userNotFound: 'このメールアドレスのユーザーが見つかりません',
        // 権限関連
        onlyOwnersCanInvite: 'オーナーのみがメンバーを招待できます',
        onlyOwnersCanRemove: 'オーナーのみがメンバーを削除できます',
        onlyOwnersCanChangeRole: 'オーナーのみが役割を変更できます',
        cannotRemoveOwner: '他のオーナーを削除できません。先に役割を変更してください',
        cannotLeaveAsOnlyOwner: '唯一のオーナーのため退会できません。先に所有権を移譲してください',
        organizationNeedsOwner: '組織には少なくとも1人のオーナーが必要です',
        accessDenied: 'アクセス拒否：この組織のメンバーではありません',
        // 組織関連
        organizationNotFound: '組織が見つかりません',
        memberNotFound: 'メンバーが見つかりません',
        userAlreadyHasOrg: 'ユーザーは既に組織に所属しています',
        invalidRole: '無効な役割です。オーナーまたはメンバーである必要があります',
        invalidCompanySize: '無効な企業規模です',
        invalidPlanType: '無効なプランタイプです',
        onlyOwnerCanUpgrade: 'オーナーのみがプランをアップグレードできます',
        // ナレッジベース関連
        knowledgeBaseNotFound: 'ナレッジベースが見つかりません',
        onlyCreatorOrOwnerCanShare: '作成者または組織オーナーのみが共有設定を変更できます',
        // 汎用
        operationFailed: '操作に失敗しました。もう一度お試しください',
        notAuthenticated: '未ログイン',
        noOrganizationFound: '組織が見つかりません',
      },
      
      // 1.3.80: サブスクリプションとプラン多言語対応
      subscriptionAndPlan: 'サブスクリプションとプラン',
      organizationInfo: '組織情報',
      businessOrganization: '企業組織',
      personalWorkspace: '個人ワークスペース',
      workspaceSuffix: 'のワークスペース', // 1.5.1: 動的ワークスペース名サフィックス
      
      // 1.4.2: 組織情報 Tab
      // 1.5.7: 不足している翻訳キーを追加（storageUsage, publicLinkUsage, サブスクリプション状態）
      orgInfo: {
        noOrganization: '組織情報が見つかりません',
        basicInfo: '基本情報',
        roleOwner: 'オーナー',
        roleMember: 'メンバー',
        orgType: '組織タイプ',
        businessOrg: '企業組織',
        personalOrg: '個人組織',
        currentPlan: '現在のプラン',
        memberCount: 'メンバー数',
        storageQuota: 'ストレージ上限',
        publicLinkQuota: '公開リンク上限',
        storageUsage: 'ストレージ使用量',
        publicLinkUsage: '訪問回数統計',
        joinedAt: '参加日',
        resourcesAndMembership: 'リソースとメンバーシップ',
        organizationOwner: '組織管理者',
        contactAdmin: '問題がある場合は管理者に連絡してください',
        invitedBy: '招待者',
        invitedYouToJoin: 'この組織への招待者',
        // サブスクリプション状態
        trialing: 'トライアル中',
        subscribed: '課金済み',
        pastDue: '支払い待ち',
        canceled: 'キャンセル済み',
      },
      trialPeriod: '無料トライアル中',
      trialDaysRemaining: '残り {{days}} 日',
      expiresOn: '有効期限',
      trialExpired: 'トライアル期間終了',
      upgradeToUnlock: 'アップグレードして全機能を解除',
      // 1.3.93: 試用期間終了ダイアログ
      trialExpiredTitle: '無料トライアルが終了しました',
      trialExpiredSubtitle: 'アップグレードして継続利用',
      trialExpiredMessage: '無料トライアル期間が終了しました。プロジェクトデータは保存されています。アップグレード後、すべての機能をご利用いただけます。',
      trialExpiredRestrictions: '現在の制限：',
      trialExpiredNoCreate: '新規プロジェクトを作成できません',
      trialExpiredNoAccess: '既存プロジェクトにアクセスできません',
      trialExpiredDataSafe: 'プロジェクトデータは安全に保存されています',
      upgradeNow: '今すぐアップグレード',
      // 1.3.98: クォータ超過ダイアログ
      storageExceededTitle: 'ストレージ容量が上限に達しました',
      storageExceededSubtitle: 'ドキュメントを削除するかアップグレードしてください',
      storageExceededMessage: 'ストレージ容量が上限に達したため、新しいドキュメントをアップロードできません。不要なドキュメントを削除するか、アップグレードして容量を増やしてください。',
      storageExceededBanner: 'ストレージ容量が上限に達しました',
      storageExceededHint: 'ドキュメントを削除するかアップグレードしてアップロードを続けてください',
      storageNoUpload: '新しいドキュメントをアップロードできません',
      storageExistingOk: '既存のドキュメントは正常に使用できます',
      storageDeleteOrUpgrade: 'ドキュメントを削除またはアップグレードで制限を解除',
      currentStorageUsage: '現在のストレージ',
      publicLinkExceededTitle: '公開アクセス回数が上限に達しました',
      publicLinkExceededSubtitle: '今月のクォータを使い切りました',
      publicLinkExceededMessage: '公開リンクのアクセス回数が今月の上限に達しました。アップグレードでより多くのアクセスクォータを取得するか、来月のリセットをお待ちください。',
      publicLinkExceededBanner: '今月の公開アクセス回数が上限に達しました',
      publicLinkExceededHint: '公開リンクは一時的に質問に回答できません。アップグレードするか来月をお待ちください',
      publicLinkExceededDisabled: '今月の公開アクセス回数が上限に達したため、一時的に質問に回答できません',
      publicLinkNoAccess: '公開リンクは一時的にアクセスできません',
      publicLinkInternalOk: '内部会話機能は正常です',
      publicLinkResetNextMonth: '来月1日にクォータが自動リセットされます',
      currentPublicLinkUsage: '今月のアクセス',
      currentRestrictions: '現在の制限：',
      quotaExceeded: 'クォータ制限を超過しました',
      quotaExceededPlaceholder: 'クォータが上限に達したため、メッセージを送信できません',
      understood: '了解しました',
      deleteHint: 'ヒント：プロジェクト詳細で不要なドキュメントを削除してストレージを解放できます。',
      subscriptionActive: 'サブスクリプション有効',
      // 1.6.57: CRM 内部アカウント/管理者オーバーライド
      internalAccount: '内部アカウント',
      internalAccountDesc: 'このアカウントは管理者により内部アカウントとして設定されており、すべての機能をご利用いただけます',
      adminOverride: '管理者承認',
      adminOverrideDesc: 'サブスクリプションステータスは管理者により手動で設定されています',
      validUntil: '有効期限',
      currentPeriod: '現在の期間',
      cancelAtPeriodEnd: '期間終了後にキャンセル予定',
      paymentPastDue: '支払い失敗',
      updatePaymentMethod: 'サービスを継続するには支払い方法を更新してください',
      maxMembers: 'メンバー上限',
      purchasedSeats: '購入済みライセンス',
      storage: 'ストレージ',
      publicLinkQuota: '公開アクセス/月',
      // 1.3.97: 使用量統計
      storageUsage: '使用量統計',
      publicVisits: 'アクセス回数統計',
      upgradePlan: 'プランをアップグレード',
      upgradeToBusiness: 'Standard にアップグレード',
      manageSubscription: 'サブスクリプション管理',
      // サブスクリプションステータスラベル
      subscriptionStatusNone: '未購読',
      subscriptionStatusTrialing: 'トライアル中',
      subscriptionStatusActive: '購読中',
      subscriptionStatusPastDue: '支払い待ち',
      subscriptionStatusCanceled: 'キャンセル済み',
      // プラン設定
      planFree: 'Free',
      planIndividual: 'Individual',
      planStandard: 'Standard',
      planFreeDesc: '無料トライアル、コア機能を体験',
      planIndividualDesc: '個人ユーザーやフリーランス向け',
      planStandardDesc: '小規模チームコラボレーション向け',
      planFeatureTrial7Days: '7日間無料トライアル',
      planFeatureBasicChat: '基本チャット機能',
      planFeature1KB: '1ナレッジベース',
      planFeatureNoPublicLink: '公開リンクなし',
      planFeature1Person: '1人利用',
      planFeature1GBStorage: '1GB ストレージ',
      planFeature5000PublicLinks: '5,000回/月 公開リンクアクセス',
      planFeatureUnlimitedChat: '無制限内部チャット',
      planFeatureAllBasicFeatures: 'すべての基本機能',
      planFeature2to50People: '2-50人チーム',
      planFeature10GBStorage: '10GB ストレージ',
      planFeature10000PublicLinks: '10,000回/月 公開リンクアクセス',
      planFeatureSharedKB: '共有ナレッジベース',
      planFeatureMemberManagement: 'メンバー管理',
      perMonth: '/月',
      perPersonPerMonth: '/人/月',
      // プランアップグレードページ
      choosePlanDescription: 'ニーズに合ったプランを選択して、より多くの機能をアンロック',
      currentPlan: '現在のプラン',
      pleaseSelectPlan: 'プランを選択してください',
      standardPriceNote: 'Standard プランは人数単位で課金、最低2人から',
      paymentNote: 'Stripe の安全な支払いページにリダイレクトされます。クレジットカード、デビットカードなど様々な支払い方法をサポート。購読後はいつでもアカウントセンターで管理またはキャンセルできます。',
      paymentSuccess: '支払い成功！サブスクリプションが有効になりました。',
      recommended: 'おすすめ',
      selectMemberCount: 'チーム人数を選択',
      people: '人',
      orderSummary: '注文概要',
      orderSummaryIndividual: 'Individual プラン × 1',
      orderSummaryStandard: 'Standard プラン × {{count}} 人',
      monthlyTotal: '月額合計',
      processing: '処理中...',
      proceedToPayment: '支払いへ進む',
      securePayment: '安全な支払い',
      upgradeError: 'アップグレードに失敗しました。後でもう一度お試しください',
      subscriptionActivated: 'サブスクリプションが有効になりました。すべての機能をご利用いただけます。',
      // 1.3.81: アカウントアップグレード（状態に応じたボタンテキスト）
      upgradeAccount: 'アカウントをアップグレード',
      adjustSeatsDescription: 'チームの席数を増減します',
      resubscribe: '再購読',
      subscriptionResumed: 'サブスクリプションが再開されました。自動更新が続きます',
      // 1.3.80: 人数調整機能
      adjustSeats: '人数を調整',
      adjustTeamSize: 'チーム人数を調整',
      currentSeats: '現在の人数',
      seats: '人',
      increaseSeatsMessage: '{{count}} 席を追加します。約 {{price}} が即時に按分課金されます',
      decreaseSeatsMessage: '{{count}} 席を削減します。次の請求サイクルから適用されます',
      proratedBilling: '現在の請求サイクルの残り日数で按分計算されます',
      newMonthlyFee: '調整後の月額',
      // 1.5.2: メンバー枠警告
      memberQuota: 'メンバー枠',
      seatsUsed: '席使用中',
      quotaFull: 'メンバー枠が上限に達しました。追加するには席を購入してください',
      quotaAlmostFull: '枠がまもなく上限に達します。アップグレードをご検討ください',
      // 1.5.5: 招待ボタン無効化メッセージ
      quotaFullCannotInvite: '席数が上限に達しているため、新しいメンバーを招待できません',
      quotaFullInviteDisabled: '席数が上限に達しています。人数を調整するか、メンバーを削除してから招待してください',
      minSeatsInfo: '最低 {{count}} 席が必要です（現在のメンバー数）',
      
      // 1.5.8: メンバー管理関連
      loadFailed: '読み込みに失敗しました',
      memberRemoved: 'メンバーを削除しました',
      roleUpdated: '役割を更新しました',
      invitationCanceled: '招待をキャンセルしました',
      memberList: 'メンバーリスト',
      pendingInvitations: '保留中の招待',
      noMembers: 'メンバーはいません',
      generateInviteLink: '招待リンクを生成',
      inviteMember: 'メンバーを招待',
      inviteLink: '招待リンク',
      expiresAt: '有効期限',
      usageCount: '使用回数',
      pending: '保留中',
      cancelInvitation: '招待をキャンセル',
      confirmCancelInvitation: 'この招待をキャンセルしますか？',
      removeMember: 'メンバーを削除',
      confirmRemoveMember: 'メンバー {{email}} を削除しますか？',
      you: 'あなた',
      joinedAt: '参加日',
      changeToMember: '一般メンバーに変更',
      changeToOwner: '管理者に変更',
      inviteSent: '招待を送信しました',
      // メンバー招待モーダル
      pleaseEnterEmail: 'メールアドレスを入力してください',
      invalidEmailFormat: 'メールアドレスの形式が正しくありません',
      createInviteFailed: '招待の作成に失敗しました',
      emailSendFailed: 'メール送信に失敗しました。招待リンクを手動で送信してください',
      inviteFailed: '招待に失敗しました',
      inviteMemberDesc: 'チームメンバーに招待メールを送信',
      emailAddress: 'メールアドレス',
      selectRole: 'メンバーの役割',
      ownerDesc: 'メンバーを管理可能',
      memberDesc: '一般メンバー',
      inviteHint: '招待メールは指定されたメールアドレスに送信されます。有効期限は7日間です',
      sending: '送信中...',
      sendInvite: '招待を送信',
      inviteCreated: '招待を作成しました',
      inviteCreatedDesc: '招待リンクが作成されました。相手に手動で送信してください',
      inviteSentDesc: '招待メールを送信しました：',
      copied: 'コピーしました',
      copy: 'コピー',
      inviteNextSteps: '招待者がメールを受け取り、リンクをクリックすると組織に参加できます。リンクの有効期限は7日間です。',
      done: '完了',
      // 基本情報タブ
      pleaseLogin: 'ログインしてください',
      basicInfo: '基本情報',
      displayName: '表示名',
      pleaseEnterName: '表示名を入力してください',
      saving: '保存中...',
      save: '保存',
      emailCannotBeChanged: 'メールアドレスは変更できません',
      loginMethod: 'ログイン方法',
      thirdPartyLoginNote: 'サードパーティアカウントでログインしているため、パスワードを変更できません',
      changePassword: 'パスワードを変更',
      newPassword: '新しいパスワード',
      pleaseEnterNewPassword: '新しいパスワードを入力してください',
      confirmPassword: 'パスワードを確認',
      pleaseConfirmPassword: 'パスワードを再入力してください',
      updating: '更新中...',
      updatePassword: 'パスワードを変更',
      updateProfileFailed: '更新に失敗しました',
      updateProfileSuccess: '更新しました',
      passwordMismatch: 'パスワードが一致しません',
      updatePasswordFailed: 'パスワードの変更に失敗しました',
      updatePasswordSuccess: 'パスワードを変更しました',
      // アカウントセンターページ
      accountCenter: 'アカウントセンター',
      accountCenterDescription: '個人情報とアカウント設定を管理',
      paymentCanceled: '支払いがキャンセルされました。',
      cancel: 'キャンセル',
      confirm: '確認',
      
      // TopNav
      cloudDocuments: 'クラウドドキュメント',
      qaChat: 'QAチャット',
      synonymLibrary: '類義語ライブラリ',
      confusingWords: '混同しやすい単語',
      startConversation: '会話を開始',
      
      // Auth Modal & Auth Page
      login: 'ログイン',
      signup: '登録',
      email: 'メールアドレス',
      password: 'パスワード',
      or: 'または',
      signInWithGoogle: 'Googleでログイン',
      noAccount: 'アカウントをお持ちでないですか？登録',
      hasAccount: 'すでにアカウントをお持ちですか？ログイン',
      operationFailed: '操作に失敗しました。再試行してください',
      googleSignInFailed: 'Googleログインに失敗しました。再試行してください',
      uiPreviewMode: 'UIプレビューモード：ログイン機能にはSupabaseの設定が必要です。docs/DEPLOYMENT.mdを参照してください。',
      uiPreviewModeGoogle: 'UIプレビューモード：Googleログイン機能にはSupabaseの設定が必要です。docs/DEPLOYMENT.mdを参照してください。',
      welcomeToYUIChat: 'YUIChatへようこそ',
      enterpriseKnowledgeBaseService: '企業ナレッジベースサービス',
      aiPoweredQA: 'AIスマート質問応答',
      multiFileSupport: '複数形式ファイルサポート',
      teamCollaboration: 'チームコラボレーション',
      welcomeBack: 'おかえりなさい',
      createAccount: 'アカウント作成',
      loginToYourAccount: 'アカウントにログイン',
      signupToGetStarted: '登録して始める',
      passwordRequirement: 'パスワードは8文字以上で、英字・数字・記号を含む必要があります',
      passwordRules: {
        length: '8文字以上',
        letter: '英字を含む',
        digit: '数字を含む',
        special: '記号を含む（例: !@#$%）',
      },
      verifyYourEmail: 'メールアドレスを確認',
      verificationEmailSent: '以下のメールアドレスに確認リンクを送信しました：',
      checkYourInbox: '受信トレイを確認し、確認リンクをクリックしてアカウントをアクティブ化してください。',
      backToLogin: 'ログインに戻る',
      forgotPassword: 'パスワードをお忘れですか？',
      forgotPasswordDescription: 'メールアドレスを入力すると、再設定メールを送信します',
      sendResetEmail: '再設定メールを送信',
      resetEmailSent: 'パスワード再設定メールを送信しました。受信トレイを確認してください',
      resetYourPassword: 'パスワードを再設定',
      resetPasswordDescription: '新しいパスワードを入力して再設定を完了してください',
      resetPassword: 'パスワードを再設定',
      passwordResetSuccess: 'パスワードを再設定しました。新しいパスワードでログインしてください',
      // 1.3.86: メール確認成功メッセージ
      emailConfirmed: 'メールアドレスの確認が完了しました！',
      pleaseLoginNow: 'メールアドレスとパスワードでログインしてください',
      processingConfirmation: 'メール確認を処理中...',
      
      // Chat Interface
      references: '参考資料：',
      page: 'ページ',
      sendMessageFailed: 'メッセージの送信に失敗しました',
      aiThinking: 'AIが考え中', // 1.2.27
      
      // Knowledge Base Page
      noData: 'データがありません',
      fileNameOrUrl: 'ファイル名/URL',
      type: 'タイプ',
      fileSize: 'ファイルサイズ',
      wordCount: '文字数',
      status: 'ステータス',
      uploadTime: 'アップロード時間',
      action: '操作',
      relearn: '再学習',
      confirmDelete: 'このドキュメントを削除してもよろしいですか？',
      confirmDeleteTitle: '選択したドキュメントを削除してもよろしいですか？', // 1.1.14: 確認削除モーダルタイトル
      confirmBatchDelete: '選択した {{count}} 件のドキュメントを削除してもよろしいですか？',
      confirmBatchDeleteTitle: '選択したドキュメントを削除してもよろしいですか？', // 1.1.14: 一括確認削除モーダルタイトル
      confirm: '確認', // 1.1.14: 確認ボタンテキスト
      batchReload: '一括再読み込み',
      batchDelete: '一括削除',
      deleting: '削除中...',
      deleteSuccess: '削除成功',
      deleteFailed: '削除失敗',
      noPermissionToDelete: 'これらのコンテンツを削除する権限がありません', // 1.5.0
      reloading: '再読み込み中...',
      reloadStarted: '再読み込みを開始しました',
      reloadFailed: '再読み込み失敗',
      fileReloadNotSupported: 'ファイルタイプのドキュメントは再読み込みをサポートしていません。再アップロードしてください',
      uiPreviewUpload: 'UIプレビューモード：ファイルアップロード機能にはSupabaseとDifyの設定が必要です。\n\ndocs/DEPLOYMENT.mdを参照してください。',
      analyzing: '分析中...',
      saving: '保存中...',
      websiteLink: 'ウェブサイトリンク',
      enterWebsiteUrl: 'ここにウェブサイトURLを入力:',
      websiteUrlPlaceholder: 'URLを入力してください (Enterキーまたは右側の"+"をクリックして追加、バッチ対応)',
      websiteUrlHint: 'URLは https:// または http:// で始まる必要があります',
      urlDuplicateError: 'このURLは既に存在します。重複して追加しないでください',
      urlFormatError: 'URL形式が正しくありません',
      add: '追加',
      remove: '削除',
      
      // Create Project Modal
      knowledgeBaseName: 'ナレッジベース名',
      knowledgeBaseNamePlaceholder: '例: スマートカスタマーサポート、製品Q&Aボット',
      description: '説明',
      descriptionPlaceholder: '重要な説明内容を入力してください...',
      oneClickGenerate: 'ワンクリック生成',
      roleSelectionHint: '役割を選択した後は切り替えできません~',
      create: '作成',
      creating: '作成中...',
      generatedDescriptionPlaceholder: 'AI生成の説明内容...',
      exampleDocument: 'サンプルドキュメント.pdf',
      productManual: '製品マニュアル.docx',
      
      // Language Switcher
      switchLanguage: '言語を切り替え',
      
      // 1.2.26: Conversation History
      conversationHistory: '会話履歴',
      newConversation: '新しい会話',
      noConversations: '会話履歴がありません',
      deleteConversation: '会話を削除',
      deleteConversationConfirm: 'この会話を削除してもよろしいですか？この操作は元に戻せません。',
      collapseConversations: '閉じる',
      loadConversationsFailed: '会話履歴の読み込みに失敗しました',
      createConversationFailed: '新しい会話の作成に失敗しました',
      loadConversationFailed: '会話の読み込みに失敗しました',
      deleteConversationSuccess: '削除成功',
      deleteConversationFailed: '削除失敗',
      pleaseSelectProject: 'プロジェクトを選択してください',
      pleaseLogin: 'ログインしてください',
      
      // 1.2.28: Public Chat Page
      publicChatLoading: '読み込み中...',
      publicChatAccessFailed: 'アクセス失敗',
      publicChatInvalidLink: 'この共有リンクは無効または期限切れです',
      publicChatContactOwner: '共有者に新しいリンクを取得するか、リンクが完全であることを確認してください。',
      publicChatAiAssistant: 'AIアシスタント',
      
      // 1.2.28: Default Questions
      defaultQuestion1: 'このプロジェクトについて紹介していただけますか？',
      defaultQuestion2: 'よくある質問は何ですか？',
      defaultQuestion3: 'このシステムの使い方は？',
      aiGeneratedDisclaimer: '上記の内容はAIによって生成されており、開発者の立場を代表するものではありません',
      
      // 1.2.52: Test Chat Interface
      internalTestInterface: 'これは内部テストインターフェースです。',
      newChat: '新しい会話',
      openPublicSharePage: '公開共有ページを開く',
      
      // Share Page
      shareDescription: '公開チャットリンクを生成して、ユーザーが直接 AI アシスタントと対話できるようにします。',
      shareLinkSettings: '共有リンク設定',
      active: '有効',
      publicAccessLink: '公開アクセスリンク（プロジェクトレベル）',
      linkCopied: 'リンクをクリップボードにコピーしました',
      tokenRefreshed: '共有トークンを更新しました',
      refreshFailed: '更新に失敗しました',
      noKnowledgeBase: 'プロジェクトが見つかりません',
      pleaseCreateKBFirst: '共有機能を有効にするには、まずプロジェクトを作成してください。',
      copy: 'コピー',
      copied: 'コピー済み',
      visit: 'アクセス',
      regenerateLink: 'リンクをリセット',
      regenerateLinkTip: 'リンクの漏洩が心配な場合は、トークンをリセットできます。古いリンクはすぐに無効になります。',
      resetLink: '共有リンクをリセット',
      shareModeInstructions: '使用説明',
      shareInstruction1: 'このリンクからあなたの専用対話インターフェースを直接開きます。',
      shareInstruction2: 'ユーザーはログインなしで、プロジェクトのすべてのドキュメントに基づいた質疑応答が可能です。',
      shareInstruction3: 'すべての会話データは「会話データ」にアーカイブされます。',
      securityNotice: 'セキュリティ通知',
      securityNoticeText: '共有リンクは適切に保管してください。ユーザーはプロジェクトを編集することはできませんが、プロジェクト内のすべてのドキュメントの公開情報にアクセスできます。',

      // Project Settings Page
      projectSettingsDescription: 'プロジェクトの基本情報を管理します',
      tabProjectInfo: 'プロジェクト情報',
      tabDigitalEmployee: 'デジタル従業員',
      tabConversation: '対話設定',
      tabSkills: 'スキル設定',
      modifyProjectInfo: 'プロジェクト名と説明を編集',
      projectName: 'プロジェクト名',
      projectNamePlaceholder: 'プロジェクト名を入力してください',
      projectDescription: 'プロジェクトの説明',
      projectDescriptionPlaceholder: 'プロジェクトの説明を入力してください',
      digitalEmployeeConfig: 'デジタル従業員の基本情報とイメージを設定',
      digitalEmployeeDeveloping: 'デジタル従業員設定機能は開発中です...',
      conversationConfig: 'AIアイコン、歓迎メッセージ、推奨質問を設定',
      // 1.3.18: パフォーマンスモード選択
      performanceMode: 'パフォーマンスモード',
      performanceModeHint: 'AI応答のパフォーマンスモードを選択',
      fastMode: '高速モード',
      fastModeDesc: '応答時間1-2秒、ロボットや電話などリアルタイム応答が必要なシナリオに適しています',
      accurateMode: '精密モード',
      accurateModeDesc: '応答時間3-7秒、テキストカスタマーサービスに適しており、AIが深く考えてより正確な結論を導きます',
      betaTag: 'Beta',
      aiAvatar: 'AIアイコン',
      clickOrDragUpload: 'クリックまたは画像をここにドラッグしてアップロード',
      avatarUploadHint: 'PNG、JPG、JPEG、GIF、WEBPをサポート、最大2MB',
      welcomeMessageMultiLang: '歓迎メッセージ（多言語）',
      recommendedQuestionsMultiLang: '推奨質問（多言語、最大3つ）',
      addQuestion: '質問を追加',
      questionIndex: '質問 {{index}}',
      saveConfig: '設定を保存',
      skillsConfig: 'AIのスキルと能力を設定',
      skillsDeveloping: 'スキル設定機能は開発中です...',
      projectNotFound: 'プロジェクトが見つかりません',
      pleaseCreateProjectFirst: 'まずプロジェクトを作成してください',
      projectAccessDenied: 'プロジェクトが存在しないか、アクセス権限がありません',
      invalidImageType: '画像ファイルをアップロードしてください（png, jpg, jpeg, gif, webp）',
      imageSizeTooLarge: 'アイコンファイルのサイズは2MBを超えてはいけません',
      invalidImageFile: '有効な画像ファイルをアップロードしてください（2MB以内）',
      maxQuestionsReached: '各言語で追加できる推奨質問は最大3つまでです',
      settingsSaved: '設定を保存しました',
      settingsSaveFailed: '保存に失敗しました。再試行してください',
      // 1.3.16: 自動翻訳機能
      autoFillOtherLangs: '他の言語に自動入力',
      autoFillHint: 'いずれかの言語でウェルカムメッセージを入力した後、「他の言語に自動入力」ボタンをクリックすると、他の言語に自動翻訳されます',
      autoFillQuestionsHint: 'いずれかの言語で推奨質問を入力した後、「他の言語に自動入力」ボタンをクリックすると、他の言語に自動翻訳されます',
      autoFillSuccess: '自動入力が完了しました',
      autoFillFailed: '自動入力に失敗しました。再試行してください',
      noSourceTextToTranslate: '先に内容を入力してください',
      
      // 1.2.54: 削除プロジェクト機能
      deleteProject: 'プロジェクトを削除',
      deleteProjectConfirmTitle: 'プロジェクトの削除を確認',
      deleteProjectConfirmDescription: 'この操作はプロジェクト「{{projectName}}」とそのすべてのドキュメントと会話記録を完全に削除します。この操作は取り消すことができません。続行しますか？',
      deleteProjectSuccess: 'プロジェクトの削除に成功しました',
      deleteProjectFailed: 'プロジェクトの削除に失敗しました',
      
      // 1.4.4: ナレッジベース共有機能
      shareWithOrganization: '組織メンバーと共有',
      shareWithOrganizationDesc: 'オンにすると、組織内のすべてのメンバーがこのナレッジベースにアクセスできます',
      sharingEnabled: '共有を有効にしました',
      sharingDisabled: '共有を無効にしました',
      toggleSharingFailed: '共有状態の更新に失敗しました',

      // 1.2.55: 空のナレッジベースメッセージ
      emptyKnowledgeBaseMessage: 'まだ知識がアップロードされていません。今すぐナレッジベースにアップロードしてください',
      goToKnowledgeBase: '今すぐ移動',
      emptyKnowledgeBasePlaceholder: '先にナレッジベースにドキュメントをアップロードしてください',
      
      // 1.3.0: follow_up 推奨質問
      followUpQuestions: '他にもこんな質問ができます：',
      
      // 1.3.11: 引用ソース表示
      citationSources: '引用ソース',
      documentSource: 'ドキュメント：{{count}}件のソース', // 1.6.8: ChatMax風引用ソースのテキスト
      relevanceScore: '関連度',
      viewSource: 'ソースを表示',
      citationNote: '最も関連性の高いドキュメント断片を表示',
      paragraph: '段落', // 1.6.14: 引用段落
      paragraphCount: '{{count}} 個の段落', // 1.6.14: 段落数
      
      // 1.3.19: 引用ソース表示設定
      citationDisplaySettings: '引用ソース表示設定',
      citationDisplaySettingsHint: 'C端チャットウィンドウでの引用ソースの表示方法を設定、管理端のテストチャットは常に引用ソースを表示',
      showCitation: '引用ソースを表示',
      showCitationDesc: 'AI回答に引用ソースリンクを表示し、右側パネルで詳細な引用内容を確認可能',
      
      // 1.3.7: ナレッジベースBanner 4ステップフロー
      bannerTitle4Steps: '4ステップでカスタマーサービスアプリを作成', // 1.6.28: タイトル変更
      bannerSubtitle4Steps: 'ファイル、ウェブサイトURLをアップロード',
      stepUploadDoc: '今すぐ作成をクリックしてドキュメントをアップロード', // 1.6.28: ステップ説明変更
      stepWaitLearning: '学習完了を待つ',
      stepTestChat: 'AIチャットで対話品質を確認', // 1.6.28: ステップ説明変更
      stepShareLink: '外部共有でカスタマーサービスアプリを公開', // 1.6.28: ステップ説明変更
      
      // 1.3.14: 会話統計とデータ管理
      projectStats: 'プロジェクト統計',
      documentStats: 'ドキュメント統計',
      totalDocuments: '総ドキュメント数',
      completed: '完了',
      processingDocs: '処理中',
      failed: '失敗',
      conversationStats: '会話統計',
      totalConversations: '総会話数',
      testLabel: 'テスト',
      publicLabel: '外部',
      testConversationLabel: 'テスト会話',
      realConversationLabel: '実際の会話',
      todayConversations: '今日の会話',
      totalMessages: '総メッセージ数',
      frequentQuestionsCount: '頻出質問数',
      completionRate: '処理完了率',
      frequentQuestions: '頻出質問',
      noFrequentQuestions: '頻出質問がありません',
      times: '回',
      projectNotExist: 'プロジェクトが存在しません',
      pleaseCreateProject: 'まずプロジェクトを作成してください',
      
      // 会話データページ
      selectDate: '日付を選択',
      allSources: 'すべてのソース',
      testConversations: 'テスト会話',
      publicConversations: '外部会話',
      searchPlaceholder: '会話内容を検索...',
      search: '検索',
      source: 'ソース',
      firstQuestion: '最初の質問',
      lastResponse: '最後の返信',
      messages: 'メッセージ',
      time: '時間',
      actions: '操作',
      noMessages: 'メッセージがありません',
      retentionSettings: 'データ保存設定',
      dataRetentionPeriod: 'データ保存期間',
      retentionPermanent: '永久',
      retention3Months: '3ヶ月',
      retention6Months: '6ヶ月',
      retention1Year: '1年',
      settings: '設定',
      
      // 1.3.30: QA問答管理
      qaManagement: 'QA問答管理',
      qaManagementDesc: '問答ペアを管理、単一作成とバッチアップロードをサポート',
      qaList: '問答ペア',
      uploadRecords: 'アップロード記録',
      createQA: '問答を作成',
      editQA: '問答を編集',
      batchUploadQA: 'バッチアップロード',
      searchQuestion: '質問を検索',
      question: '質問',
      answer: '回答',
      userQuestion: 'ユーザーの質問',
      replyAnswer: '回答内容',
      similarQuestions: '類似質問',
      inputQuestion: 'ユーザーの質問を入力してください',
      inputAnswer: '回答内容を入力してください',
      inputSimilarQuestion: '類似質問を入力してください',
      addSimilarQuestion: '類似質問を追加',
      questionRequired: 'ユーザーの質問を入力してください',
      answerRequired: '回答内容を入力してください',
      answerHint: 'リッチテキスト形式をサポート、リンクや画像を含めることができます',
      selectProject: 'まずプロジェクトを選択してください',
      saveSuccess: '保存しました',
      saveFailed: '保存に失敗しました',
      statusPending: '学習待ち',
      statusLearned: '学習成功',
      statusFailed2: '学習失敗',
      sourceCustom: 'カスタム編集',
      sourceBatch: 'バッチアップロード',
      updateTime: '更新日時',
      allLearned: 'すべて学習済み',
      noQAData: '問答データがありません',
      createFirstQA: '最初の問答を作成',
      confirmDeleteQA: 'この問答を削除してもよろしいですか？',
      selectedCount: '{{count}} 件を選択',
      paginationInfo: '{{start}}-{{end}} 件を表示、合計 {{total}} 件',
      prevPage: '前のページ',
      nextPage: '次のページ',
      // バッチアップロードモーダル
      templateDownloadHint: 'テンプレート形式に従って問答データを入力し、xlsxファイルをアップロードしてください。',
      downloadTemplate: 'テンプレートをダウンロード',
      multipleQuestionsHint: '同じ回答に複数の質問がある場合は、"|"で区切ってください',
      uploadDocument: 'クリックまたはファイルをドラッグしてアップロード',
      uploadHint: 'xlsx形式をサポート、最大20MB',
      onlyXlsxSupported: 'xlsx形式のファイルのみサポート',
      fileTooLarge: 'ファイルサイズが20MBを超えています',
      selectFile: 'ファイルを選択してください',
      removeFile: 'ファイルを削除',
      uploadComplete: 'アップロード完了',
      totalRecords: '総件数',
      successRecords: '成功件数',
      failedRecords: '失敗件数',
      parseErrors: '解析エラー',
      andMore: '他 {{count}} 件...',
      noUploadRecords: 'アップロード記録がありません',
      filename: 'ファイル名',
      totalCount: '総件数',
      successCount: '成功数',
      failedCount: '失敗数',
      
      // 1.3.78: Onboarding ページ
      onboarding: {
        welcomeTitle: 'YuiChatへようこそ',
        selectScenario: 'ご利用シーンを選択してください',
        personalUser: '個人ユーザー',
        personalUserDesc: '個人の学習・研究に最適',
        businessUser: '企業ユーザー',
        businessUserDesc: 'チームコラボレーション、企業向け',
        // 料金関連
        individualUsers: '1人',
        standardUsers: '2〜50人',
        perPersonMonth: '人/月',
        free7Days: '7日間無料トライアル',
        popular: 'おすすめ',
        unlimitedChat: '内部会話無制限',
        publicLink5000: '公開リンク配額 5,000回/月',
        publicLink10000: '公開リンク配額 10,000回/月',
        unlimitedKB: 'ナレッジベース数無制限',
        storage1GBPerson: 'ストレージ 1GB/人',
        storage10GB: 'ストレージ 10GB',
        multiUser: '複数ユーザーアカウント',
        sharedKB: '共有ナレッジベース',
        rolePermissions: 'Owner/Member 権限管理',
        overageNote: '超過後は公開アクセス一時停止、翌月リセット',
        // 旧翻訳保持
        storage1GB: '1GB ストレージ',
        multiMember: '複数メンバー協業',
        unlimitedKBShared: '無制限のナレッジベース + 共有',
        select: '選択',
        upgradeAnytime: 'いつでも「設定」から企業ユーザーにアップグレードできます',
        successTitle: '登録完了！',
        successDesc: '個人ユーザーとして登録されました',
        tipTitle: 'ヒント',
        tipContent: 'チームコラボレーションやエンタープライズ機能が必要な場合は、「設定 > アカウント」からいつでも企業ユーザーにアップグレードできます。すべてのデータは保持されます。',
        startUsing: 'YuiChatを始める',
        createFailed: '作成に失敗しました。もう一度お試しください',
        backToLogin: 'ログインに戻る',
      },
      // 1.4.2: 招待ページ
      invite: {
        joinOrganization: '組織に参加',
        invitedToJoin: '招待されています',
        roleLabel: '役割',
        roleMember: 'メンバー',
        roleOwner: 'オーナー',
        roleJoin: 'として参加',
        willJoinAs: 'あなたは',
        currentAccount: '現在のアカウント',
        inviteExpiresAt: '招待の有効期限',
        decline: '辞退',
        acceptInvite: '招待を受ける',
        loginToAcceptInvite: 'ログインまたは登録して招待を受ける',
        loginTab: 'ログイン',
        registerTab: '登録',
        continueWithGoogle: 'Googleでログイン',
        signUpWithGoogle: 'Googleで登録',
        or: 'または',
        email: 'メールアドレス',
        enterEmail: 'メールアドレスを入力',
        password: 'パスワード',
        enterPassword: 'パスワードを入力',
        setPassword: 'パスワードを設定（8文字以上、英字+数字+記号）',
        loginAndJoin: 'ログインして参加',
        registerAndJoin: '登録して参加',
        verifyingInvite: '招待を確認中...',
        inviteInvalid: '招待リンクが無効です',
        invalidInviteLink: '無効な招待リンク',
        inviteExpired: '招待リンクが期限切れか無効です',
        backToHome: 'ホームに戻る',
        joinedOrganization: '組織に参加しました',
        acceptFailed: '参加に失敗しました',
        checkEmailForConfirmation: 'メールを確認して認証を完了してください',
        // 1.5.6: マルチウィンドウシナリオの翻訳
        alreadyJoined: '組織に参加しました',
        alreadyJoinedDesc: '別のウィンドウで組織に参加しました',
        joinedAs: 'あなたの役割',
        closeTabHint: 'このウィンドウを閉じて、別のウィンドウで続けることができます',
        confirmAndClose: '確認',
      },
      // 1.3.81: 登録ページ
      register: {
        welcomeTitle: 'YuiChat アカウントを作成',
        selectUserType: 'ご利用シーンを選択してください',
        personalRegisterTitle: '個人ユーザー登録',
        personalRegisterSubtitle: 'メールアドレスとパスワードで個人アカウントを作成',
        businessRegisterTitle: '企業ユーザー登録',
        businessRegisterSubtitle: '企業情報を入力して管理者アカウントを作成',
        businessInfoSection: '企業情報',
        accountInfoSection: 'アカウント情報',
        emailRequired: 'メールアドレスを入力してください',
        passwordRequired: 'パスワードを入力してください',
        registering: '登録中...',
        registerAndVerify: '登録して確認メールを送信',
        alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
        businessInfoSaved: '企業情報を保存しました',
        businessInfoSavedDesc: 'メールアドレスを確認後、「{{companyName}}」の企業アカウントが自動作成され、あなたが管理者になります。',
      },
      // 1.3.78: 企業情報ページ
      businessSetup: {
        back: '戻る',
        backToLogin: 'ログインに戻る',
        title: '企業情報を入力',
        subtitle: '企業アカウントを作成するために以下の情報を入力してください',
        companyName: '企業名',
        companyNamePlaceholder: '企業名を入力してください',
        companyNameRequired: '企業名を入力してください',
        companySize: '企業規模',
        companySizeRequired: '企業規模を選択してください',
        size1to5: '2-5 人',
        size6to20: '6-20 人',
        size21to50: '21-50 人',
        size51plus: '51人以上',
        industry: '業種',
        industryPlaceholder: '業種を選択してください',
        industryTech: 'IT/インターネット',
        industryFinance: '金融/銀行',
        industryHealthcare: '医療/ヘルスケア',
        industryEducation: '教育/研修',
        industryManufacturing: '製造業',
        industryRetail: '小売/Eコマース',
        industryConsulting: 'コンサルティング/サービス',
        industryMedia: 'メディア/広告',
        industryGovernment: '官公庁/公共サービス',
        industryOther: 'その他',
        jobTitle: '役職',
        jobTitlePlaceholder: '例：プロダクトマネージャー、技術責任者',
        optional: '任意',
        completeRegistration: '登録完了',
        creating: '作成中...',
        createFailed: '作成に失敗しました。もう一度お試しください',
        adminNote: '作成後、あなたはこの企業の管理者となり、チームメンバーを招待できます',
      },
      // 1.3.40: ランディングページ
      landing: {
        // ナビゲーション
        navProblem: '課題',
        navSolution: 'ソリューション',
        navROI: '投資対効果',
        navFeatures: '機能',
        navCases: '事例',
        navPricing: '料金',
        freeTrial: '無料トライアル',
        
        // Hero
        heroTitle: '社員の質問に、1秒で回答',
        heroTitleHtml: '社員の疑問を、<span class="highlight">1秒</span>で解決',
        heroSubtitle: '50%の重複質問削減 · 年間300万円のコスト削減',
        heroSubtitleHtml: '重複問い合わせ <span class="number">50%</span> 削減<span class="divider">|</span>年間コスト <span class="number">¥300万</span> ダウン',
        featureInstant: '即時対応',
        featureInstantDesc: '待ち時間ゼロ',
        featureCost: 'コスト削減',
        featureCostDesc: '年間240万円以上削減',
        featureSecurity: '安全管理',
        featureSecurityDesc: 'データ完全隔離',
        // 価値カード
        valueSpeed: '圧倒的なスピード',
        valueSpeedDesc: '待ち時間ゼロ。社員の生産性を最大化し、業務を止めない。',
        valueCost: '管理コストの削減',
        valueCostDesc: 'バックオフィスの負荷を半減。コア業務への集中リソースを創出。',
        valueEasy: '誰でも使える簡便性',
        valueEasyDesc: 'ITスキル不要。マニュアルなしで、今日から使える。',
        tryFree7Days: '7日間無料トライアル',
        bookDemo: 'デモを予約',
        servedCompanies: '500社以上の企業にご利用いただいています',
        
        // Problem Section
        problemTitle: '御社はこのような課題を抱えていませんか？',
        problemSubtitle: '従業員は毎日平均1.8時間を情報検索に費やしています。変革の時です',
        problemStat1Label: '業務時間の浪費',
        problemStat2Label: '平均待ち時間',
        problemStat3Label: '1日の検索時間',
        problem1Title: '人件費の高騰',
        problem1Desc: 'カスタマーサポート、人事、IT部門が毎日同じ質問に繰り返し回答し、専門家の時間が低付加価値作業に浪費され、人件費が高止まりしています。',
        problem2Title: '対応速度の遅さ',
        problem2Desc: '従業員が質問してから回答を得るまで平均2〜4時間かかり、業務が中断され、業務プロセスの効率が低下しています。',
        problem3Title: '知識の分散・混乱',
        problem3Desc: 'ドキュメントが各システムやフォルダに散在し、従業員が見つけられない、正確でない、完全でないという問題があり、情報のサイロ化が深刻です。',
        
        // Solution Section
        solutionTitle: 'シンプルなソリューション',
        solutionHeadline: 'ファイルをアップロードすれば、社員が自分で答えを見つけられる',
        solutionHeadlineHtml: 'ファイルをアップロードするだけ。<br/>従業員が<span class="highlight">自分で答えを見つける</span>世界へ',
        pillar1Title: 'コスト削減',
        pillar1Desc: '50%の重複質問削減\n人件費大幅削減',
        pillar2Title: '時間短縮',
        pillar2Desc: '1秒で回答\n業務フローを中断しない',
        pillar3Title: '手間削減',
        pillar3Desc: '24時間自動対応\n人手不要',
        // Solution Cards
        solution1Title: 'コスト削減',
        solution1DescHtml: '重複する問い合わせを<br/><span class="number">50%</span>削減',
        solution2Title: '時間短縮',
        solution2DescHtml: '待ち時間ゼロ。<br/><span class="number">1秒</span>で答えを入手',
        solution3Title: 'ストレスフリー',
        solution3DescHtml: '担当者の不在を気にせず<br/><span class="number">24時間</span>自動対応',
        noCode: 'プログラミング不要 · トレーニング不要 · 3分で導入完了',
        
        // ROI Section
        roiTitle: '目に見える投資対効果',
        roiSubtitle: '月額1.5万円の投資で年間240万円削減 - 500人規模企業の試算',
        roiRate: '投資収益率',
        roiRateDesc: '業界トップレベル',
        paybackPeriod: '投資回収期間',
        paybackPeriodDesc: '素早い回収',
        annualSaving: '年間削減額',
        annualSavingDesc: '継続的なコスト削減',
        efficiencyUp: '効率向上',
        efficiencyUpDesc: 'ビジネス成長を加速',
        days: '日',
        tenThousand: '万円',
        
        // Comparison Section
        comparisonTitle: '見える投資対効果',
        comparisonSubtitle: '従来の方法 vs YUIChat',
        traditionalMethod: '従来の手動方式',
        traditionalMethodDesc: 'サポート、人事、IT部門が同じ質問に繰り返し回答、人件費が高止まり',
        yuichatMethodDesc: 'AIスマートQ&Aが24時間365日自動対応、人件費を大幅削減',
        annualLaborCost: '年間人件費',
        annualSystemCost: '年間システムコスト',
        annualSave: '年間削減額',
        
        // Steps Section
        stepsTitle: '3ステップで始める、技術スキル不要',
        stepsSubtitle: 'シンプルなのに驚くほど強力',
        step1Title: 'ファイルをアップロード',
        step1Desc: 'ドラッグ＆ドロップで完了。PDF、Word、Excel、PPT、Webページなど多形式に対応。システムが自動で解析・学習。',
        step2Title: '社員が質問',
        step2Desc: 'チャットのように簡単。自然言語で質問でき、キーワードを覚える必要なし。AIが質問の意図を理解。',
        step3Title: 'すぐに回答を取得',
        step3Desc: '1秒以内で応答。正確な回答と出典の自動引用。追跡可能で信頼できる。',
        noTraining1: 'トレーニング不要',
        noTraining2: '技術者不要',
        noTraining3: '3分で導入完了',
        
        // Efficiency Section
        efficiencyTitle: '実際の効率改善データ',
        efficiencySubtitle: '導入前後の比較 - 実際の顧客データに基づく',
        efficiency1Title: '初回応答時間',
        efficiency1Before: '導入前: 平均2時間',
        efficiency1Improve: '90%以上短縮',
        efficiency2Title: 'AI自動解決率',
        efficiency2Before: '導入前: 0%（すべて手動）',
        efficiency2Improve: '問い合わせ激減',
        efficiency3Title: '問題解決速度',
        efficiency3Before: '導入前: 平均5分',
        efficiency3Improve: '80%効率化',
        second: '秒',
        minute: '分',
        
        // Cases Section
        casesTitle: 'お客様の成功事例',
        casesSubtitle: 'すでにYUIChatを使用し、顕著な成果を上げています',
        case1Quote: '導入はわずか3日。今では毎月50時間の作業時間を削減し、社員はドキュメント探しに悩まなくなりました。',
        case1Company: '製造業企業',
        case1Scale: '500人規模',
        case1Stat1: '3日で導入',
        case1Stat2: '月50時間削減',
        case2Quote: '顧客満足度が70%から92%に向上。サポートチームの負担が大幅に軽減され、より価値のある仕事に時間を使えるようになりました。',
        case2Company: 'SaaS企業',
        case2Scale: '200人規模',
        case2Stat1: '満足度92%',
        case2Stat2: '対応5倍高速化',
        case3Quote: '新入社員の研修期間が60%短縮。入社初日から必要な情報を自分で見つけられ、人事の作業量が大幅に削減されました。',
        case3Company: '教育機関',
        case3Scale: '研修業界',
        case3Stat1: '研修期間-60%',
        case3Stat2: '人事効率+80%',
        
        // Features Section
        featuresTitle: '強力な機能、シンプルな操作',
        featuresSubtitle: 'エンタープライズ機能、コンシューマー体験',
        feature1Title: '多形式対応',
        feature1Desc: 'PDF/Word/Excel/PPT/Webページすべて対応',
        feature2Title: 'スマートQ&A',
        feature2Desc: 'ドキュメント内容に基づく正確な回答',
        feature3Title: 'ワンクリック共有',
        feature3Desc: '外部アクセスリンクを生成',
        feature4Title: '多言語対応',
        feature4Desc: '中国語/英語/日本語ネイティブ対応',
        feature5Title: 'データ統計',
        feature5Desc: 'Q&A記録と分析',
        feature6Title: 'セキュリティ分離',
        feature6Desc: 'プロジェクトレベルのデータ分離',
        feature7Title: 'セマンティックキャッシュ',
        feature7Desc: '類似質問<500ms応答',
        feature8Title: 'おすすめ質問',
        feature8Desc: 'よくある質問を自動生成',
        
        // Pricing Section
        pricingTitle: '料金プラン',
        pricingSubtitle: 'ご利用に合ったプランをお選びください',
        pricingTypeIndividual: '個人',
        pricingTypeEnterprise: '企業',
        pricingIndividualUsers: '1名',
        pricingStandardUsers: '2～50名',
        pricingEnterpriseUsers: '51名以上',
        pricingPerPerson: '人/月',
        pricingPerson: '人',
        pricingContactUs: 'お問い合わせ',
        pricingUnlimitedChat: '内部チャット無制限',
        pricingPublicLink: '公開リンク配額',
        pricingTimesMonth: '回/月',
        pricingTimesPersonMonth: '回/人/月',
        pricingUnlimitedKB: 'ナレッジベース数無制限',
        pricingStorage: 'ストレージ',
        pricingCustom: 'カスタム',
        pricingPopular: 'おすすめ',
        pricingMultiUser: '複数ユーザーアカウント',
        pricingSharedKB: '共有ナレッジベース',
        pricingRoleOwnerMember: 'Owner/Member ロール権限',
        pricingAllStandardFeatures: 'Standard全機能を含む',
        pricingDedicatedSupport: '専属技術サポート',
        pricingFeatureComparison: '機能比較',
        pricingFeature: '機能',
        pricingAccountManagement: 'アカウント管理',
        pricingInviteMembers: 'メンバー招待',
        pricingKnowledgeBase: 'ナレッジベース',
        pricingPersonalKB: '個人ナレッジベース',
        pricingRolePermission: 'ロール権限',
        pricingRoleOwner: 'オーナー',
        pricingRoleMember: 'メンバー',
        pricingOverage: '超過後は公開アクセス一時停止、翌月リセット',
        pricingNote: '全プラン7日間無料トライアル付き · いつでもアップグレード・ダウングレード可能',
        
        // CTA Section
        ctaTitle: '今すぐ始めて、素早く回収',
        ctaSubtitle: '企業知識の価値最大化、最も賢い投資',
        ctaLowCost: '圧倒的な低コスト',
        ctaQuickPayback: '素早い投資回収',
        ctaSave240: '年間582万円削減',
        ctaCostReduction: '継続的なコスト削減',
        ctaZeroTech: '技術スキル不要',
        ctaQuickDeploy: '3分で導入完了',
        month: '月',
        bookDemoExec: '経営層向けデモを予約',
        trustSecurity: 'エンタープライズセキュリティ認証',
        trustPrivate: 'プライベートクラウド導入対応',
        trustSupport: '24時間365日テクニカルサポート',
        
        // Footer
        footerDesc: 'エンタープライズAIナレッジベース管理プラットフォーム\n企業の知識をすぐ手の届くところに。AIスマートQ&Aで知識取得コストを削減し、業務効率を向上',
        footerProduct: '製品',
        footerSolution: 'ソリューション',
        footerFeatures: '機能',
        footerCases: '導入事例',
        footerPricing: '料金プラン',
        footerResources: 'リソース',
        footerDocs: '製品ドキュメント',
        footerAPI: 'APIドキュメント',
        footerBlog: 'ブログ',
        footerHelp: 'ヘルプセンター',
        footerContact: 'お問い合わせ',
        footerLocation: '日本 · 東京',
        footerPrivacy: 'プライバシーポリシー',
        footerTerms: '利用規約',
      },
    }
  },
  en: {
    translation: {
      appTitle: 'YUIChat',
      appSubtitle: 'Enterprise Knowledge Base Service',
      knowledgeBase: 'Knowledge Management',
      knowledgeBaseTitle: 'Too many enterprise knowledge resources, too messy?',
      knowledgeBaseSubtitle: 'Files, audio/video, websites, create a knowledge base in 5 seconds',
      createNow: 'Create Now',
      createOnlineDoc: 'Create Online Document',
      allDocuments: 'All Documents',
      searchFileName: 'Search file name/URL',
      uploadKnowledgeBase: 'Upload Knowledge Base',
      localFiles: 'Local Files',
      supportedFormats: 'Supported formats: txt, pdf, docx, pptx, xlsx',
      dragFilesHere: 'Drag files here, or',
      selectFiles: 'select files',
      maxFileSize: 'Single file maximum 50 MB',
      maxAudioFileSize: 'Single file maximum 1GB',
      supportsMultipleFiles: 'Supports uploading multiple files',
      singleFileUploadOnly: 'Only supports single file upload',
      audioSupportedFormats: 'Supported formats: mp4, mp3, wav',
      selectedFile: 'Selected File',
      waitForTraining: 'After file upload, need to wait for training to be "completed"',
      maxDocumentChars: 'According to your plan, supports generating questions for documents up to 10,000 characters',
      canCloseDuringUpload: 'You can close this window during the upload process to continue other operations',
      selectedFiles: 'Selected Files',
      previousStep: 'Previous Step',
      autoGenerateQA: 'Automatically generate Q&A',
      startUpload: 'Start Upload',
      uploading: 'Uploading...',
      uploadSuccess: 'Success', // 1.6.26
      uploadFailed: 'Failed', // 1.6.26
      maxFilesLimit: 'Maximum {{max}} files per upload', // 1.6.26
      maxFilesExceeded: 'File limit exceeded. Only the first {{max}} files will be uploaded', // 1.6.26
      urlProcessing: 'Processing', // 1.6.27
      urlSuccess: 'Success', // 1.6.27
      urlFailed: 'Failed', // 1.6.27
      analyzeAudioVideo: 'Analyze Audio/Video',
      audioVideoSubtitle: 'Support various audio/video to subtitle files',
      websiteAnalysis: 'Website Analysis',
      websiteAnalysisDesc: 'Enter website link, analyze website information',
      statusProcessing: 'Learning',
      statusCompleted: 'Learning Successful',
      statusFailed: 'Learning Failed',
      uploadedWaitingProcessing: 'Uploaded successfully, processing...',
      chatMode: 'Chat',
      chatWelcomeTitle: 'AI Knowledge Base Assistant',
      chatWelcomeMessage: 'Based on your knowledge base, I can answer your questions!',
      chatInputPlaceholder: 'Tell me your question...',
      chatError: 'Error occurred',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      
      // Navigation & Sidebar
      projectSettings: 'Project Settings',
      testChat: 'AI Chat',
      externalShare: 'External Share',
      dashboard: 'Dashboard',
      allProjects: 'All Projects',
      createProject: 'Create Project',
      exampleProject: 'Example Project',
      conversationData: 'Conversation Data',
      currentProject: 'Current Project',
      currentOrganization: 'Current Organization', // 1.4.6
      selectOrganization: 'Select Organization', // 1.4.6
      business: 'Business', // 1.4.6
      personal: 'Personal', // 1.4.6
      owner: 'Owner', // 1.4.6
      member: 'Member', // 1.4.6
      account: 'Account',
      user: 'User',
      signOut: 'Sign Out',
      defaultProject: 'Default Project',
      accountCenter: 'Account Center', // 1.2.6
      feedback: 'Feedback', // 1.2.6
      back: 'Back', // 1.2.29
      
      // Account Center Page - 1.2.29
      accountCenterDescription: 'Manage your personal information and account settings',
      basicInfo: 'Basic Information',
      displayName: 'Display Name',
      pleaseEnterName: 'Please enter your name',
      emailCannotBeChanged: 'Email address cannot be changed',
      loginMethod: 'Login Method',
      thirdPartyLoginNote: 'You are using a third-party account to log in. Your password is managed by that service provider. To change your password, please do so at the corresponding service provider.',
      changePassword: 'Change Password',
      newPassword: 'New Password',
      pleaseEnterNewPassword: 'Please enter new password',
      confirmPassword: 'Confirm Password',
      pleaseConfirmPassword: 'Please enter new password again',
      updatePassword: 'Update Password',
      updating: 'Updating...',
      updateProfileSuccess: 'Profile updated successfully',
      updateProfileFailed: 'Failed to update profile',
      updatePasswordSuccess: 'Password updated successfully',
      updatePasswordFailed: 'Failed to update password',
      passwordMismatch: 'Passwords do not match',
      
      // Feedback Page - 1.2.29
      feedbackDescription: 'We value your opinions and suggestions, please share your thoughts',
      note: 'Note',
      feedbackNote: 'Your feedback is very important to us. We read every feedback carefully and continuously improve our product.',
      
      // 1.3.85: Authentication error messages multi-language
      authErrors: {
        invalidCredentials: 'Invalid email or password',
        emailNotConfirmed: 'Email not confirmed. Please check your verification email',
        userAlreadyRegistered: 'This email is already registered',
        credentialTooShort: 'Password must be at least 8 characters with letters, numbers, and symbols',
        invalidEmailFormat: 'Invalid email format',
        signupDisabled: 'Sign up is currently disabled',
        emailRateLimitExceeded: 'Email rate limit exceeded. Please try again later',
        rateLimitExceeded: 'For security reasons, please try again in 60 seconds',
        networkError: 'Network connection error. Please check your connection and try again',
        serviceUnavailable: 'Service is temporarily unavailable. Please try again later',
        invalidOrExpiredResetToken: 'Reset link is invalid or expired',
      },

      // 1.5.3: API/Organization related error messages
      apiErrors: {
        // Invitation related
        invalidInvitationLink: 'Invalid invitation link',
        invitationNoLongerValid: 'This invitation is no longer valid',
        invitationExpired: 'This invitation has expired',
        invitationMaxUsage: 'This invitation has reached its maximum usage limit',
        invitationWrongEmail: 'This invitation is for a specific email address',
        alreadyMember: 'You are already a member of this organization',
        organizationMaxMembers: 'This organization has reached its maximum member limit',
        userAlreadyMember: 'User is already a member of this organization',
        userNotFound: 'User not found with this email',
        // Permission related
        onlyOwnersCanInvite: 'Only owners can invite members',
        onlyOwnersCanRemove: 'Only owners can remove members',
        onlyOwnersCanChangeRole: 'Only owners can change member roles',
        cannotRemoveOwner: 'Cannot remove another owner. Change their role first',
        cannotLeaveAsOnlyOwner: 'Cannot leave: you are the only owner. Transfer ownership first',
        organizationNeedsOwner: 'Organization must have at least one owner',
        accessDenied: 'Access denied: not a member of this organization',
        // Organization related
        organizationNotFound: 'Organization not found',
        memberNotFound: 'Member not found',
        userAlreadyHasOrg: 'User already has an organization',
        invalidRole: 'Invalid role. Must be owner or member',
        invalidCompanySize: 'Invalid company size',
        invalidPlanType: 'Invalid plan type',
        onlyOwnerCanUpgrade: 'Only owner can upgrade plan',
        // Knowledge base related
        knowledgeBaseNotFound: 'Knowledge base not found',
        onlyCreatorOrOwnerCanShare: 'Only the creator or organization owner can change sharing settings',
        // Generic
        operationFailed: 'Operation failed. Please try again',
        notAuthenticated: 'Not authenticated',
        noOrganizationFound: 'No organization found',
      },
      
      // 1.3.80: Subscription & Plan multi-language
      subscriptionAndPlan: 'Subscription & Plan',
      organizationInfo: 'Organization Info',
      businessOrganization: 'Business Organization',
      personalWorkspace: 'Personal Workspace',
      workspaceSuffix: "'s Workspace", // 1.5.1: Dynamic workspace name suffix
      
      // 1.4.2: Organization Info Tab
      // 1.5.7: Add missing translation keys (storageUsage, publicLinkUsage, subscription status)
      orgInfo: {
        noOrganization: 'Organization not found',
        basicInfo: 'Basic Info',
        roleOwner: 'Owner',
        roleMember: 'Member',
        orgType: 'Organization Type',
        businessOrg: 'Business Organization',
        personalOrg: 'Personal Organization',
        currentPlan: 'Current Plan',
        memberCount: 'Member Count',
        storageQuota: 'Storage Quota',
        publicLinkQuota: 'Public Link Quota',
        storageUsage: 'Storage Usage',
        publicLinkUsage: 'Visit Statistics',
        joinedAt: 'Joined At',
        resourcesAndMembership: 'Resources & Membership',
        organizationOwner: 'Organization Admin',
        contactAdmin: 'Contact admin if you have any issues',
        invitedBy: 'Invited By',
        invitedYouToJoin: 'Invited you to join this organization',
        // Subscription status
        trialing: 'Trialing',
        subscribed: 'Subscribed',
        pastDue: 'Past Due',
        canceled: 'Canceled',
      },
      trialPeriod: 'Free Trial',
      trialDaysRemaining: '{{days}} days remaining',
      expiresOn: 'Expires on',
      trialExpired: 'Trial Expired',
      upgradeToUnlock: 'Upgrade to unlock all features',
      // 1.3.93: Trial expired modal
      trialExpiredTitle: 'Free Trial Expired',
      trialExpiredSubtitle: 'Upgrade to continue using',
      trialExpiredMessage: 'Your free trial has ended. Your project data is saved. Upgrade to continue using all features.',
      trialExpiredRestrictions: 'Current restrictions:',
      trialExpiredNoCreate: 'Cannot create new projects',
      trialExpiredNoAccess: 'Cannot access existing projects',
      trialExpiredDataSafe: 'Project data is safely preserved',
      upgradeNow: 'Upgrade Now',
      // 1.3.98: Quota exceeded modal
      storageExceededTitle: 'Storage Full',
      storageExceededSubtitle: 'Please delete some documents or upgrade',
      storageExceededMessage: 'Your storage space has reached its limit. You cannot upload new documents. Please delete some documents or upgrade to get more storage space.',
      storageExceededBanner: 'Storage Full',
      storageExceededHint: 'Please delete some documents or upgrade to continue uploading',
      storageNoUpload: 'Cannot upload new documents',
      storageExistingOk: 'Existing documents work normally',
      storageDeleteOrUpgrade: 'Delete documents or upgrade to remove restrictions',
      currentStorageUsage: 'Current Storage',
      publicLinkExceededTitle: 'Public Access Limit Reached',
      publicLinkExceededSubtitle: 'Monthly quota exhausted',
      publicLinkExceededMessage: 'Your public link access has reached its monthly limit. Upgrade to get more access quota, or wait for next month\'s reset.',
      publicLinkExceededBanner: 'Monthly public access limit reached',
      publicLinkExceededHint: 'Public link temporarily cannot answer questions. Please upgrade or wait until next month',
      publicLinkExceededDisabled: 'Monthly public access limit reached, temporarily cannot answer questions',
      publicLinkNoAccess: 'Public link temporarily unavailable',
      publicLinkInternalOk: 'Internal chat functions normally',
      publicLinkResetNextMonth: 'Quota resets automatically on the 1st of next month',
      currentPublicLinkUsage: 'Monthly Visits',
      currentRestrictions: 'Current restrictions:',
      quotaExceeded: 'Quota limit exceeded',
      quotaExceededPlaceholder: 'Quota limit reached, cannot send messages',
      understood: 'I Understand',
      deleteHint: 'Tip: You can delete unwanted documents in project details to free up storage space.',
      subscriptionActive: 'Subscription Active',
      // 1.6.57: CRM internal account/admin override
      internalAccount: 'Internal Account',
      internalAccountDesc: 'This account is set as internal by an admin and has full access',
      adminOverride: 'Admin Override',
      adminOverrideDesc: 'Subscription status is manually set by an admin',
      validUntil: 'Valid until',
      currentPeriod: 'Current Period',
      cancelAtPeriodEnd: 'Will cancel at end of period',
      paymentPastDue: 'Payment Failed',
      updatePaymentMethod: 'Please update your payment method to continue the service',
      maxMembers: 'Max Members',
      purchasedSeats: 'Purchased license',
      storage: 'Storage',
      publicLinkQuota: 'Public Access/Month',
      // 1.3.97: Usage statistics
      storageUsage: 'Usage stats',
      publicVisits: 'Visit stats',
      upgradePlan: 'Upgrade Plan',
      upgradeToBusiness: 'Upgrade to Standard',
      manageSubscription: 'Manage Subscription',
      // Subscription status labels
      subscriptionStatusNone: 'Not Subscribed',
      subscriptionStatusTrialing: 'Trialing',
      subscriptionStatusActive: 'Subscribed',
      subscriptionStatusPastDue: 'Past Due',
      subscriptionStatusCanceled: 'Canceled',
      // Plan configurations
      planFree: 'Free',
      planIndividual: 'Individual',
      planStandard: 'Standard',
      planFreeDesc: 'Free trial, experience core features',
      planIndividualDesc: 'For individual users or freelancers',
      planStandardDesc: 'For small team collaboration',
      planFeatureTrial7Days: '7-day free trial',
      planFeatureBasicChat: 'Basic chat features',
      planFeature1KB: '1 knowledge base',
      planFeatureNoPublicLink: 'No public links',
      planFeature1Person: '1 user',
      planFeature1GBStorage: '1GB storage',
      planFeature5000PublicLinks: '5,000/month public link access',
      planFeatureUnlimitedChat: 'Unlimited internal chat',
      planFeatureAllBasicFeatures: 'All basic features',
      planFeature2to50People: '2-50 person team',
      planFeature10GBStorage: '10GB storage',
      planFeature10000PublicLinks: '10,000/month public link access',
      planFeatureSharedKB: 'Shared knowledge base',
      planFeatureMemberManagement: 'Member management',
      perMonth: '/month',
      perPersonPerMonth: '/person/month',
      // Plan upgrade page
      choosePlanDescription: 'Choose the plan that fits your needs to unlock more features',
      currentPlan: 'Current Plan',
      pleaseSelectPlan: 'Please select a plan',
      standardPriceNote: 'Standard plan is billed per person, minimum 2 people',
      paymentNote: 'You will be redirected to Stripe secure payment page to complete the payment. Supports credit cards, debit cards, and various payment methods. After subscription, you can manage or cancel anytime in Account Center.',
      paymentSuccess: 'Payment successful! Subscription activated.',
      recommended: 'Recommended',
      selectMemberCount: 'Select Team Size',
      people: ' people',
      orderSummary: 'Order Summary',
      orderSummaryIndividual: 'Individual Plan × 1',
      orderSummaryStandard: 'Standard Plan × {{count}} people',
      monthlyTotal: 'Monthly Total',
      processing: 'Processing...',
      proceedToPayment: 'Proceed to Payment',
      securePayment: 'Secure Payment',
      upgradeError: 'Upgrade failed, please try again later',
      subscriptionActivated: 'Your subscription is now active. You can now use all features.',
      // 1.3.81: Account upgrade (button text varies by status)
      upgradeAccount: 'Upgrade Account',
      adjustSeatsDescription: 'Increase or decrease team seats',
      resubscribe: 'Resubscribe',
      subscriptionResumed: 'Subscription resumed. Auto-renewal will continue',
      // 1.3.80: Adjust seats feature
      adjustSeats: 'Adjust Seats',
      adjustTeamSize: 'Adjust Team Size',
      currentSeats: 'Current Seats',
      seats: ' seats',
      increaseSeatsMessage: 'Adding {{count}} seat(s). Approximately {{price}} will be charged immediately (prorated)',
      decreaseSeatsMessage: 'Removing {{count}} seat(s). This will take effect from the next billing cycle',
      proratedBilling: 'Prorated based on remaining days in current billing cycle',
      newMonthlyFee: 'New Monthly Fee',
      // 1.5.2: Member quota warnings
      memberQuota: 'Member Quota',
      seatsUsed: 'seats used',
      quotaFull: 'Member quota reached. To add more users, please purchase additional seats',
      quotaAlmostFull: 'Quota almost full. Please consider upgrading your plan',
      // 1.5.5: Invite button disabled messages
      quotaFullCannotInvite: 'Seat quota full, cannot invite new members',
      quotaFullInviteDisabled: 'Seat quota full. Please adjust seats or remove members before inviting',
      minSeatsInfo: 'Minimum {{count}} seats required (current member count)',
      
      // 1.5.8: Member management related
      loadFailed: 'Failed to load',
      memberRemoved: 'Member removed',
      roleUpdated: 'Role updated',
      invitationCanceled: 'Invitation canceled',
      memberList: 'Member List',
      pendingInvitations: 'Pending Invitations',
      noMembers: 'No members yet',
      generateInviteLink: 'Generate Invite Link',
      inviteMember: 'Invite Member',
      inviteLink: 'Invite Link',
      expiresAt: 'Expires at',
      usageCount: 'Usage count',
      pending: 'Pending',
      cancelInvitation: 'Cancel Invitation',
      confirmCancelInvitation: 'Are you sure you want to cancel this invitation?',
      removeMember: 'Remove Member',
      confirmRemoveMember: 'Are you sure you want to remove member {{email}}?',
      you: 'You',
      joinedAt: 'Joined at',
      changeToMember: 'Change to Member',
      changeToOwner: 'Change to Admin',
      inviteSent: 'Invitation sent',
      // Invite member modal
      pleaseEnterEmail: 'Please enter email address',
      invalidEmailFormat: 'Invalid email format',
      createInviteFailed: 'Failed to create invitation',
      emailSendFailed: 'Failed to send email. Please send the invite link manually',
      inviteFailed: 'Invitation failed',
      inviteMemberDesc: 'Send an invitation email to team members',
      emailAddress: 'Email Address',
      selectRole: 'Member Role',
      ownerDesc: 'Can manage members',
      memberDesc: 'Regular member',
      inviteHint: 'Invitation email will be sent to the specified address. Valid for 7 days',
      sending: 'Sending...',
      sendInvite: 'Send Invite',
      inviteCreated: 'Invitation created',
      inviteCreatedDesc: 'Invite link created. Please send it manually',
      inviteSentDesc: 'Invitation email sent to',
      copied: 'Copied',
      copy: 'Copy',
      inviteNextSteps: 'The invitee will receive an email and can join the organization by clicking the link. Link is valid for 7 days.',
      done: 'Done',
      // Basic info tab
      pleaseLogin: 'Please login first',
      basicInfo: 'Basic Info',
      displayName: 'Display Name',
      pleaseEnterName: 'Please enter display name',
      saving: 'Saving...',
      save: 'Save',
      emailCannotBeChanged: 'Email address cannot be changed',
      loginMethod: 'Login Method',
      thirdPartyLoginNote: 'Logged in with third-party account. Password cannot be changed',
      changePassword: 'Change Password',
      newPassword: 'New Password',
      pleaseEnterNewPassword: 'Please enter new password',
      confirmPassword: 'Confirm Password',
      pleaseConfirmPassword: 'Please re-enter password',
      updating: 'Updating...',
      updatePassword: 'Update Password',
      updateProfileFailed: 'Update failed',
      updateProfileSuccess: 'Update successful',
      passwordMismatch: 'Passwords do not match',
      updatePasswordFailed: 'Failed to change password',
      updatePasswordSuccess: 'Password changed successfully',
      // Account center page
      accountCenter: 'Account Center',
      accountCenterDescription: 'Manage your personal information and account settings',
      paymentCanceled: 'Payment canceled.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      
      // TopNav
      cloudDocuments: 'Cloud Documents',
      qaChat: 'QA Chat',
      synonymLibrary: 'Synonym Library',
      confusingWords: 'Confusing Words',
      startConversation: 'Start Conversation',
      
      // Auth Modal & Auth Page
      login: 'Login',
      signup: 'Sign Up',
      email: 'Email',
      password: 'Password',
      or: 'or',
      signInWithGoogle: 'Sign in with Google',
      noAccount: "Don't have an account? Sign up",
      hasAccount: 'Already have an account? Sign in',
      operationFailed: 'Operation failed, please try again',
      googleSignInFailed: 'Google sign in failed, please try again',
      uiPreviewMode: 'UI Preview Mode: Login feature requires Supabase configuration. Please refer to docs/DEPLOYMENT.md for setup.',
      uiPreviewModeGoogle: 'UI Preview Mode: Google sign in feature requires Supabase configuration. Please refer to docs/DEPLOYMENT.md for setup.',
      welcomeToYUIChat: 'Welcome to YUIChat',
      enterpriseKnowledgeBaseService: 'Enterprise Knowledge Base Service',
      aiPoweredQA: 'AI-Powered Q&A',
      multiFileSupport: 'Multi-Format File Support',
      teamCollaboration: 'Team Collaboration',
      welcomeBack: 'Welcome Back',
      createAccount: 'Create Account',
      loginToYourAccount: 'Login to your account',
      signupToGetStarted: 'Sign up to get started',
      passwordRequirement: 'Password must be at least 8 characters with letters, numbers, and symbols',
      passwordRules: {
        length: 'At least 8 characters',
        letter: 'Contains a letter',
        digit: 'Contains a number',
        special: 'Contains a symbol (e.g. !@#$%)',
      },
      verifyYourEmail: 'Verify Your Email',
      verificationEmailSent: 'We have sent a verification link to:',
      checkYourInbox: 'Please check your inbox and click the verification link to activate your account.',
      backToLogin: 'Back to Login',
      forgotPassword: 'Forgot password?',
      forgotPasswordDescription: 'Enter your email and we will send you a password reset link',
      sendResetEmail: 'Send reset email',
      resetEmailSent: 'Password reset email sent. Please check your inbox',
      resetYourPassword: 'Reset your password',
      resetPasswordDescription: 'Enter a new password to complete reset',
      resetPassword: 'Reset password',
      passwordResetSuccess: 'Password reset successful. Please sign in with your new password',
      // 1.3.86: Email confirmation success message
      emailConfirmed: 'Email verified successfully!',
      pleaseLoginNow: 'Please login with your email and password',
      processingConfirmation: 'Processing email verification...',
      
      // Chat Interface
      references: 'References:',
      page: 'Page',
      sendMessageFailed: 'Failed to send message',
      aiThinking: 'AI is thinking', // 1.2.27
      
      // Knowledge Base Page
      noData: 'No data',
      fileNameOrUrl: 'File Name/URL',
      type: 'Type',
      fileSize: 'File Size',
      wordCount: 'Word Count',
      status: 'Status',
      uploadTime: 'Upload Time',
      action: 'Action',
      relearn: 'Relearn',
      confirmDelete: 'Are you sure you want to delete this document?',
      confirmDeleteTitle: 'Are you sure you want to delete the selected document?', // 1.1.14: Confirm delete modal title
      confirmBatchDelete: 'Are you sure you want to delete the selected {{count}} document(s)?',
      confirmBatchDeleteTitle: 'Are you sure you want to delete the selected document?', // 1.1.14: Confirm batch delete modal title
      confirm: 'Confirm', // 1.1.14: Confirm button text
      batchReload: 'Batch Reload',
      batchDelete: 'Batch Delete',
      deleting: 'Deleting...',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed',
      noPermissionToDelete: 'No permission to delete these items', // 1.5.0
      reloading: 'Reloading...',
      reloadStarted: 'Reload started',
      reloadFailed: 'Reload failed',
      fileReloadNotSupported: 'File type documents do not support reload. Please re-upload',
      uiPreviewUpload: 'UI Preview Mode: File upload feature requires Supabase and Dify configuration.\n\nPlease refer to docs/DEPLOYMENT.md for setup.',
      analyzing: 'Analyzing...',
      saving: 'Saving...',
      websiteLink: 'Website Link',
      enterWebsiteUrl: 'Enter website URL here:',
      websiteUrlPlaceholder: 'Please enter URL (press Enter or click "+" on the right to add, supports batch)',
      websiteUrlHint: 'URL must start with https:// or http://',
      urlDuplicateError: 'This URL already exists, please do not add it repeatedly',
      urlFormatError: 'URL format is invalid',
      add: 'Add',
      remove: 'Remove',
      
      // Create Project Modal
      knowledgeBaseName: 'Knowledge Base Name',
      knowledgeBaseNamePlaceholder: 'e.g., Smart Customer Support, Product Q&A Bot',
      description: 'Description',
      descriptionPlaceholder: 'Please enter key description content...',
      oneClickGenerate: 'One-click Generate',
      roleSelectionHint: 'Role cannot be switched after selection~',
      create: 'Create',
      creating: 'Creating...',
      generatedDescriptionPlaceholder: 'AI-generated description content...',
      exampleDocument: 'Example Document.pdf',
      productManual: 'Product Manual.docx',
      
      // Language Switcher
      switchLanguage: 'Switch Language',
      
      // 1.2.26: Conversation History
      conversationHistory: 'Conversation History',
      newConversation: 'New Conversation',
      noConversations: 'No conversations',
      deleteConversation: 'Delete Conversation',
      deleteConversationConfirm: 'Are you sure you want to delete this conversation? This action cannot be undone.',
      collapseConversations: 'Collapse',
      loadConversationsFailed: 'Failed to load conversations',
      createConversationFailed: 'Failed to create new conversation',
      loadConversationFailed: 'Failed to load conversation',
      deleteConversationSuccess: 'Deleted successfully',
      deleteConversationFailed: 'Delete failed',
      pleaseSelectProject: 'Please select a project',
      pleaseLogin: 'Please login',
      
      // 1.2.28: Public Chat Page
      publicChatLoading: 'Loading...',
      publicChatAccessFailed: 'Access Failed',
      publicChatInvalidLink: 'This share link is invalid or has expired',
      publicChatContactOwner: 'Please contact the sharer for a new link, or check if the link is complete.',
      publicChatAiAssistant: 'AI Assistant',

      // 1.2.28: Default Questions
      defaultQuestion1: 'Can you introduce this project?',
      defaultQuestion2: 'What are the common questions?',
      defaultQuestion3: 'How to use this system?',
      aiGeneratedDisclaimer: 'The above content is generated by AI and does not represent the developer\'s position',
      
      // 1.2.52: Test Chat Interface
      internalTestInterface: 'This is an internal test interface.',
      newChat: 'New Chat',
      openPublicSharePage: 'Open Public Share Page',

      // Share Page
      shareDescription: 'Generate a public chat link to let your users directly interact with the AI assistant.',
      shareLinkSettings: 'Share Link Settings',
      active: 'Active',
      publicAccessLink: 'Public Access Link (Project Level)',
      linkCopied: 'Link copied to clipboard',
      tokenRefreshed: 'Share token refreshed',
      refreshFailed: 'Refresh failed',
      noKnowledgeBase: 'Project not found',
      pleaseCreateKBFirst: 'Please create a project first to enable the sharing feature.',
      copy: 'Copy',
      copied: 'Copied',
      visit: 'Visit',
      regenerateLink: 'Reset Link',
      regenerateLinkTip: 'If you are concerned about link leakage, you can reset the token. The old link will immediately become invalid.',
      resetLink: 'Reset Share Link',
      shareModeInstructions: 'Instructions',
      shareInstruction1: 'This link directly opens your exclusive chat interface.',
      shareInstruction2: 'Users can perform Q&A based on all project documents without logging in.',
      shareInstruction3: 'All conversation data will be archived in "Conversation Data".',
      securityNotice: 'Security Notice',
      securityNoticeText: 'Please keep your share link safe. While users cannot modify your project, they can access public information of all documents in the project.',

      // Project Settings Page
      projectSettingsDescription: 'Manage project basic information',
      tabProjectInfo: 'Project Info',
      tabDigitalEmployee: 'Digital Employee',
      tabConversation: 'Conversation',
      tabSkills: 'Skills',
      modifyProjectInfo: 'Modify project name and description',
      projectName: 'Project Name',
      projectNamePlaceholder: 'Please enter project name',
      projectDescription: 'Project Description',
      projectDescriptionPlaceholder: 'Please enter project description',
      digitalEmployeeConfig: 'Configure digital employee basic information and avatar',
      digitalEmployeeDeveloping: 'Digital employee configuration is under development...',
      conversationConfig: 'Configure AI avatar, welcome message, and recommended questions',
      // 1.3.18: Performance mode selection
      performanceMode: 'Performance Mode',
      performanceModeHint: 'Select the performance mode for AI responses',
      fastMode: 'Fast Mode',
      fastModeDesc: 'Response time 1-2 seconds, suitable for robots, phone calls and other real-time response scenarios',
      accurateMode: 'Accurate Mode',
      accurateModeDesc: 'Response time 3-7 seconds, suitable for text customer service, AI draws more accurate conclusions through deep thinking',
      betaTag: 'Beta',
      aiAvatar: 'AI Avatar',
      clickOrDragUpload: 'Click or drag image here to upload',
      avatarUploadHint: 'Supports PNG, JPG, JPEG, GIF, WEBP, max 2MB',
      welcomeMessageMultiLang: 'Welcome Message (Multi-language)',
      recommendedQuestionsMultiLang: 'Recommended Questions (Multi-language, max 3)',
      addQuestion: 'Add Question',
      questionIndex: 'Question {{index}}',
      saveConfig: 'Save Config',
      skillsConfig: 'Configure AI skills and capabilities',
      skillsDeveloping: 'Skills configuration is under development...',
      projectNotFound: 'Project not found',
      pleaseCreateProjectFirst: 'Please create a project first',
      projectAccessDenied: 'Project does not exist or access denied',
      invalidImageType: 'Please upload an image file (png, jpg, jpeg, gif, webp)',
      imageSizeTooLarge: 'Avatar file size cannot exceed 2MB',
      invalidImageFile: 'Please upload a valid image file (max 2MB)',
      maxQuestionsReached: 'Maximum 3 recommended questions per language',
      settingsSaved: 'Settings saved',
      settingsSaveFailed: 'Save failed, please try again',
      // 1.3.16: Auto-translate feature
      autoFillOtherLangs: 'Auto-fill other languages',
      autoFillHint: 'After entering a welcome message in any language, click "Auto-fill other languages" to automatically translate and fill in other languages',
      autoFillQuestionsHint: 'After entering recommended questions in any language, click "Auto-fill other languages" to automatically translate and fill in other languages',
      autoFillSuccess: 'Auto-fill completed successfully',
      autoFillFailed: 'Auto-fill failed, please try again',
      noSourceTextToTranslate: 'Please enter content first',
      
      // 1.2.54: Delete project feature
      deleteProject: 'Delete Project',
      deleteProjectConfirmTitle: 'Confirm Delete Project',
      deleteProjectConfirmDescription: 'This action will permanently delete the project "{{projectName}}" along with all its documents and conversation records. This action cannot be undone. Continue?',
      deleteProjectSuccess: 'Project deleted successfully',
      deleteProjectFailed: 'Failed to delete project',
      
      // 1.4.4: Knowledge base sharing feature
      shareWithOrganization: 'Share with Organization',
      shareWithOrganizationDesc: 'When enabled, all organization members can access this knowledge base',
      sharingEnabled: 'Sharing enabled',
      sharingDisabled: 'Sharing disabled',
      toggleSharingFailed: 'Failed to update sharing status',

      // 1.2.55: Empty knowledge base message
      emptyKnowledgeBaseMessage: 'No knowledge uploaded yet. Please go to the knowledge base to upload now',
      goToKnowledgeBase: 'Go Now',
      emptyKnowledgeBasePlaceholder: 'Please upload documents to the knowledge base first',
      
      // 1.3.0: follow_up recommended questions
      followUpQuestions: 'You might also want to ask:',
      
      // 1.3.11: Citation sources display
      citationSources: 'Citation Sources',
      documentSource: 'Sources: {{count}} document(s)', // 1.6.8: ChatMax style citation text
      relevanceScore: 'Relevance',
      viewSource: 'View Source',
      citationNote: 'Showing the most relevant document snippets',
      paragraph: 'Paragraph', // 1.6.14: Citation paragraph
      paragraphCount: '{{count}} paragraph(s)', // 1.6.14: Paragraph count
      
      // 1.3.19: Citation display settings
      citationDisplaySettings: 'Citation Display Settings',
      citationDisplaySettingsHint: 'Configure how citation sources are displayed in the C-side chat window. Admin test chat always shows citations',
      showCitation: 'Show Citations',
      showCitationDesc: 'Display citation source links in AI responses with detailed panel on the right',
      
      // 1.3.7: Knowledge Base Banner 4-step flow
      bannerTitle4Steps: '4 Steps to Create Customer Service App', // 1.6.28: Title change
      bannerSubtitle4Steps: 'Upload files, website URLs',
      stepUploadDoc: 'Click Create & Upload Documents', // 1.6.28: Step description change
      stepWaitLearning: 'Wait for Learning',
      stepTestChat: 'Test AI Chat Quality', // 1.6.28: Step description change
      stepShareLink: 'Share App Publicly', // 1.6.28: Step description change
      
      // 1.3.14: Conversation statistics and data management
      projectStats: 'Project Statistics',
      documentStats: 'Document Statistics',
      totalDocuments: 'Total Documents',
      completed: 'Completed',
      processingDocs: 'Processing',
      failed: 'Failed',
      conversationStats: 'Conversation Statistics',
      totalConversations: 'Total Conversations',
      testLabel: 'Test',
      publicLabel: 'Public',
      testConversationLabel: 'Test Conversation',
      realConversationLabel: 'Real Conversation',
      todayConversations: 'Today\'s Conversations',
      totalMessages: 'Total Messages',
      frequentQuestionsCount: 'Frequent Questions',
      completionRate: 'Completion Rate',
      frequentQuestions: 'Frequent Questions',
      noFrequentQuestions: 'No frequent questions',
      times: 'times',
      projectNotExist: 'Project does not exist',
      pleaseCreateProject: 'Please create a project first',
      
      // Conversation data page
      selectDate: 'Select Date',
      allSources: 'All Sources',
      testConversations: 'Test Conversations',
      publicConversations: 'Public Conversations',
      searchPlaceholder: 'Search conversations...',
      search: 'Search',
      source: 'Source',
      firstQuestion: 'First Question',
      lastResponse: 'Last Response',
      messages: 'Messages',
      time: 'Time',
      actions: 'Actions',
      noMessages: 'No messages',
      retentionSettings: 'Retention Settings',
      dataRetentionPeriod: 'Data Retention Period',
      retentionPermanent: 'Permanent',
      retention3Months: '3 Months',
      retention6Months: '6 Months',
      retention1Year: '1 Year',
      settings: 'Settings',
      
      // 1.3.30: QA Management
      qaManagement: 'QA Management',
      qaManagementDesc: 'Manage QA pairs, supports single creation and batch upload',
      qaList: 'QA Pairs',
      uploadRecords: 'Upload Records',
      createQA: 'Create QA',
      editQA: 'Edit QA',
      batchUploadQA: 'Batch Upload QA',
      searchQuestion: 'Search question',
      question: 'Question',
      answer: 'Answer',
      userQuestion: 'User Question',
      replyAnswer: 'Reply Answer',
      similarQuestions: 'Similar Questions',
      inputQuestion: 'Please enter user question',
      inputAnswer: 'Please enter reply answer',
      inputSimilarQuestion: 'Please enter similar question',
      addSimilarQuestion: 'Add Similar Question',
      questionRequired: 'Please enter user question',
      answerRequired: 'Please enter reply answer',
      answerHint: 'Supports rich text format, can include links, images, etc.',
      selectProject: 'Please select a project first',
      saveSuccess: 'Saved successfully',
      saveFailed: 'Save failed',
      statusPending: 'Pending',
      statusLearned: 'Learned',
      statusFailed2: 'Failed',
      sourceCustom: 'Custom Edit',
      sourceBatch: 'Batch Upload',
      updateTime: 'Update Time',
      allLearned: 'All Learned',
      noQAData: 'No QA data',
      createFirstQA: 'Create First QA',
      confirmDeleteQA: 'Are you sure you want to delete this QA?',
      selectedCount: '{{count}} selected',
      paginationInfo: 'Showing {{start}}-{{end}} of {{total}}',
      prevPage: 'Previous',
      nextPage: 'Next',
      // Batch upload modal
      templateDownloadHint: 'Please fill in QA data according to the template format, then upload the xlsx file.',
      downloadTemplate: 'Download Template',
      multipleQuestionsHint: 'If multiple questions correspond to the same answer, separate them with "|"',
      uploadDocument: 'Click or drag file here to upload',
      uploadHint: 'Supports xlsx format, max 20MB',
      onlyXlsxSupported: 'Only xlsx format files are supported',
      fileTooLarge: 'File size exceeds 20MB limit',
      selectFile: 'Please select a file',
      removeFile: 'Remove file',
      uploadComplete: 'Upload complete',
      totalRecords: 'Total records',
      successRecords: 'Success',
      failedRecords: 'Failed',
      parseErrors: 'Parse errors',
      andMore: 'and {{count}} more...',
      noUploadRecords: 'No upload records',
      filename: 'Filename',
      totalCount: 'Total',
      successCount: 'Success',
      failedCount: 'Failed',
      
      // 1.3.78: Onboarding Page
      onboarding: {
        welcomeTitle: 'Welcome to YuiChat',
        selectScenario: 'Select your usage scenario',
        personalUser: 'Personal User',
        personalUserDesc: 'For personal learning and research',
        businessUser: 'Business User',
        businessUserDesc: 'For team collaboration and enterprise use',
        // Pricing related
        individualUsers: '1 Person',
        standardUsers: '2-50 People',
        perPersonMonth: 'person/month',
        free7Days: '7-Day Free Trial',
        popular: 'Popular',
        unlimitedChat: 'Unlimited internal conversations',
        publicLink5000: 'Public link quota 5,000/month',
        publicLink10000: 'Public link quota 10,000/month',
        unlimitedKB: 'Unlimited knowledge bases',
        storage1GBPerson: 'Storage 1GB/person',
        storage10GB: 'Storage 10GB',
        multiUser: 'Multi-user accounts',
        sharedKB: 'Shared knowledge bases',
        rolePermissions: 'Owner/Member role permissions',
        overageNote: 'Public access paused after overage, resets next month',
        // Legacy translations
        storage1GB: '1GB storage',
        multiMember: 'Multi-member collaboration',
        unlimitedKBShared: 'Unlimited knowledge bases + sharing',
        select: 'Select',
        upgradeAnytime: 'You can upgrade to Business anytime from Settings',
        successTitle: 'Registration Complete!',
        successDesc: 'You have registered as a personal user',
        tipTitle: 'Tip',
        tipContent: 'If you need team collaboration or enterprise features later, you can upgrade to Business anytime in "Settings > Account". All your data will be preserved.',
        startUsing: 'Start Using YuiChat',
        createFailed: 'Creation failed, please try again',
        backToLogin: 'Back to Login',
      },
      // 1.4.2: Invite Page
      invite: {
        joinOrganization: 'Join Organization',
        invitedToJoin: 'You have been invited to join',
        roleLabel: 'Role',
        roleMember: 'Member',
        roleOwner: 'Owner',
        roleJoin: 'role',
        willJoinAs: 'You will join as',
        currentAccount: 'Current Account',
        inviteExpiresAt: 'Invite expires on',
        decline: 'Decline',
        acceptInvite: 'Accept Invite',
        loginToAcceptInvite: 'Log in or sign up to accept the invite',
        loginTab: 'Log In',
        registerTab: 'Sign Up',
        continueWithGoogle: 'Continue with Google',
        signUpWithGoogle: 'Sign up with Google',
        or: 'or',
        email: 'Email',
        enterEmail: 'Enter your email',
        password: 'Password',
        enterPassword: 'Enter your password',
        setPassword: 'Set password (8+ chars, letters+numbers+symbols)',
        loginAndJoin: 'Log In & Join',
        registerAndJoin: 'Sign Up & Join',
        verifyingInvite: 'Verifying invite...',
        inviteInvalid: 'Invalid Invite Link',
        invalidInviteLink: 'Invalid invite link',
        inviteExpired: 'Invite link has expired or is invalid',
        backToHome: 'Back to Home',
        joinedOrganization: 'Successfully joined organization',
        acceptFailed: 'Failed to join',
        checkEmailForConfirmation: 'Please check your email to complete verification',
        // 1.5.6: Multi-window scenario translations
        alreadyJoined: 'Already Joined',
        alreadyJoinedDesc: 'You have already joined the organization through another window',
        joinedAs: 'Your role',
        closeTabHint: 'You can close this tab and continue in the other window',
        confirmAndClose: 'Confirm',
      },
      // 1.3.81: Register Page
      register: {
        welcomeTitle: 'Create Your YuiChat Account',
        selectUserType: 'Select your usage scenario',
        personalRegisterTitle: 'Personal User Registration',
        personalRegisterSubtitle: 'Create your personal account with email and password',
        businessRegisterTitle: 'Business User Registration',
        businessRegisterSubtitle: 'Fill in business info and create admin account',
        businessInfoSection: 'Business Information',
        accountInfoSection: 'Account Information',
        emailRequired: 'Please enter email address',
        passwordRequired: 'Please enter password',
        registering: 'Registering...',
        registerAndVerify: 'Register & Send Verification Email',
        alreadyHaveAccount: 'Already have an account?',
        businessInfoSaved: 'Business info saved',
        businessInfoSavedDesc: 'After verifying your email, a business account for "{{companyName}}" will be automatically created, and you will become its admin.',
      },
      // 1.3.78: Business Setup Page
      businessSetup: {
        back: 'Back',
        backToLogin: 'Back to Login',
        title: 'Complete Business Info',
        subtitle: 'Please fill in the following information to create your business account',
        companyName: 'Company Name',
        companyNamePlaceholder: 'Enter company name',
        companyNameRequired: 'Please enter company name',
        companySize: 'Company Size',
        companySizeRequired: 'Please select company size',
        size1to5: '2-5 people',
        size6to20: '6-20 people',
        size21to50: '21-50 people',
        size51plus: '51+ people',
        industry: 'Industry',
        industryPlaceholder: 'Select industry',
        industryTech: 'Technology/Internet',
        industryFinance: 'Finance/Banking',
        industryHealthcare: 'Healthcare',
        industryEducation: 'Education/Training',
        industryManufacturing: 'Manufacturing',
        industryRetail: 'Retail/E-commerce',
        industryConsulting: 'Consulting/Services',
        industryMedia: 'Media/Communications',
        industryGovernment: 'Government/Public Services',
        industryOther: 'Other',
        jobTitle: 'Your Position',
        jobTitlePlaceholder: 'e.g., Product Manager, Tech Lead',
        optional: 'Optional',
        completeRegistration: 'Complete Registration',
        creating: 'Creating...',
        createFailed: 'Creation failed, please try again',
        adminNote: 'After creation, you will become the admin of this organization and can invite team members',
      },
      // 1.3.40: Landing Page
      landing: {
        // Navigation
        navProblem: 'Pain Points',
        navSolution: 'Solution',
        navROI: 'ROI',
        navFeatures: 'Features',
        navCases: 'Cases',
        navPricing: 'Pricing',
        freeTrial: 'Free Trial',
        
        // Hero
        heroTitle: 'Get answers to employee questions in 1 second',
        heroTitleHtml: 'Solve employee questions in <span class="highlight">1 second</span>',
        heroSubtitle: 'Reduce 50% repetitive inquiries · Save ¥3M annually',
        heroSubtitleHtml: 'Reduce repetitive inquiries <span class="number">50%</span><span class="divider">|</span>Annual cost savings <span class="number">¥3M</span>',
        featureInstant: 'Instant Response',
        featureInstantDesc: 'Zero waiting time',
        featureCost: 'Cost Reduction',
        featureCostDesc: 'Save ¥2.4M+ annually',
        featureSecurity: 'Secure & Controlled',
        featureSecurityDesc: 'Complete data isolation',
        // Value Cards
        valueSpeed: 'Overwhelming Speed',
        valueSpeedDesc: 'Zero waiting time. Maximize employee productivity without stopping work.',
        valueCost: 'Management Cost Reduction',
        valueCostDesc: 'Cut back-office workload in half. Free up resources for core business.',
        valueEasy: 'Easy for Everyone',
        valueEasyDesc: 'No IT skills required. No manual needed, start using it today.',
        tryFree7Days: 'Try Free for 7 Days',
        bookDemo: 'Book a Demo',
        servedCompanies: 'Trusted by 500+ enterprises',
        
        // Problem Section
        problemTitle: 'Is your enterprise facing these challenges?',
        problemSubtitle: 'On average, each employee wastes 1.8 hours per day searching for information. It\'s time for change',
        problemStat1Label: 'Time Wasted',
        problemStat2Label: 'Avg. Wait Time',
        problemStat3Label: 'Daily Search Time',
        problem1Title: 'Rising Labor Costs',
        problem1Desc: 'Customer service, HR, and IT departments repeatedly answer the same questions daily. Expert time is wasted on low-value work, keeping labor costs high.',
        problem2Title: 'Slow Response Times',
        problem2Desc: 'Employees wait an average of 2-4 hours for answers after asking questions. Work is interrupted, and business processes suffer from low efficiency.',
        problem3Title: 'Scattered Knowledge',
        problem3Desc: 'Documents are scattered across systems and folders. Employees can\'t find, can\'t find accurately, or can\'t find completely. Information silos are severe.',
        
        // Solution Section
        solutionTitle: 'A Simple Solution',
        solutionHeadline: 'Upload files, and employees can find answers themselves',
        solutionHeadlineHtml: 'Just upload files.<br/>A world where employees <span class="highlight">find answers themselves</span>',
        pillar1Title: 'Save Money',
        pillar1Desc: 'Reduce 50% repetitive inquiries\nSignificantly lower labor costs',
        pillar2Title: 'Save Time',
        pillar2Desc: 'Get answers in 1 second\nNo workflow interruption',
        pillar3Title: 'Peace of Mind',
        pillar3Desc: '24/7 automated service\nNo manual supervision needed',
        // Solution Cards
        solution1Title: 'Cost Saving',
        solution1DescHtml: 'Reduce repetitive inquiries<br/><span class="number">50%</span> reduction',
        solution2Title: 'Time Saving',
        solution2DescHtml: 'Zero waiting time.<br/>Get answers in <span class="number">1 second</span>',
        solution3Title: 'Stress Free',
        solution3DescHtml: 'No need to wait for staff<br/><span class="number">24 hours</span> auto-response',
        noCode: 'No coding · No training · Deploy in 3 minutes',
        
        // ROI Section
        roiTitle: 'Visible Return on Investment',
        roiSubtitle: 'Invest ¥15K/month, save ¥2.4M/year - Based on 500-employee enterprise',
        roiRate: 'ROI',
        roiRateDesc: 'Industry-leading',
        paybackPeriod: 'Payback Period',
        paybackPeriodDesc: 'Quick return',
        annualSaving: 'Annual Savings',
        annualSavingDesc: 'Continuous cost reduction',
        efficiencyUp: 'Efficiency Boost',
        efficiencyUpDesc: 'Accelerate business growth',
        days: ' days',
        tenThousand: '0K',
        
        // Comparison Section
        comparisonTitle: 'Visible Return on Investment',
        comparisonSubtitle: 'Traditional Method vs YUIChat',
        traditionalMethod: 'Traditional Manual Method',
        traditionalMethodDesc: 'Support, HR, IT teams repeatedly answer same questions, keeping labor costs high',
        yuichatMethodDesc: 'AI smart Q&A responds automatically 24/7, significantly reducing labor costs',
        annualLaborCost: 'Annual labor cost',
        annualSystemCost: 'Annual system cost',
        annualSave: 'Annual savings',
        
        // Steps Section
        stepsTitle: '3 Steps to Get Started, Zero Technical Skills Required',
        stepsSubtitle: 'Incredibly simple, yet surprisingly powerful',
        step1Title: 'Upload Files',
        step1Desc: 'Just drag and drop. Supports PDF, Word, Excel, PPT, web pages, and more. System automatically parses and learns.',
        step2Title: 'Employees Ask Questions',
        step2Desc: 'As simple as chatting. Ask in natural language, no need to remember keywords. AI understands the intent.',
        step3Title: 'Get Answers Instantly',
        step3Desc: 'Response within 1 second. Accurate answers with automatic source citations. Traceable and trustworthy.',
        noTraining1: 'No Training',
        noTraining2: 'No Tech Staff',
        noTraining3: 'Deploy in 3 Min',
        
        // Efficiency Section
        efficiencyTitle: 'Real Efficiency Improvement Data',
        efficiencySubtitle: 'Before and after comparison - Based on real customer data',
        efficiency1Title: 'First Response Time',
        efficiency1Before: 'Before: Average 2 hours',
        efficiency1Improve: '90%+ reduction',
        efficiency2Title: 'AI Auto-Resolution Rate',
        efficiency2Before: 'Before: 0% (all manual)',
        efficiency2Improve: 'Inquiries drastically reduced',
        efficiency3Title: 'Problem Resolution Speed',
        efficiency3Before: 'Before: Average 5 minutes',
        efficiency3Improve: '80% efficiency gain',
        second: 's',
        minute: 'min',
        
        // Cases Section
        casesTitle: 'Customer Success Stories',
        casesSubtitle: 'They are already using YUIChat with remarkable results',
        case1Quote: 'Deployment took only 3 days. Now we save 50 hours per month, and employees no longer struggle to find documents.',
        case1Company: 'Manufacturing Enterprise',
        case1Scale: '500 employees',
        case1Stat1: '3-day deployment',
        case1Stat2: '50 hrs/month saved',
        case2Quote: 'Customer satisfaction rose from 70% to 92%. Support team pressure greatly reduced, finally time for more valuable work.',
        case2Company: 'SaaS Company',
        case2Scale: '200 employees',
        case2Stat1: '92% satisfaction',
        case2Stat2: '5x faster response',
        case3Quote: 'New employee training cycle reduced by 60%. From day one, they can find needed information themselves. HR workload significantly reduced.',
        case3Company: 'Education Institution',
        case3Scale: 'Training industry',
        case3Stat1: 'Training -60%',
        case3Stat2: 'HR efficiency +80%',
        
        // Features Section
        featuresTitle: 'Powerful Features, Simple to Use',
        featuresSubtitle: 'Enterprise-grade features, consumer-grade experience',
        feature1Title: 'Multi-format Support',
        feature1Desc: 'PDF/Word/Excel/PPT/Web pages all supported',
        feature2Title: 'Smart Q&A',
        feature2Desc: 'Accurate answers based on document content',
        feature3Title: 'One-click Share',
        feature3Desc: 'Generate external access links',
        feature4Title: 'Multi-language',
        feature4Desc: 'Native support for Chinese/English/Japanese',
        feature5Title: 'Data Analytics',
        feature5Desc: 'Q&A records and analysis',
        feature6Title: 'Security Isolation',
        feature6Desc: 'Project-level data isolation',
        feature7Title: 'Semantic Cache',
        feature7Desc: 'Similar questions <500ms response',
        feature8Title: 'Recommended Questions',
        feature8Desc: 'Auto-generate common questions',
        
        // Pricing Section
        pricingTitle: 'Pricing Plans',
        pricingSubtitle: 'Choose the plan that fits your needs',
        pricingTypeIndividual: 'Individual',
        pricingTypeEnterprise: 'Enterprise',
        pricingIndividualUsers: '1 user',
        pricingStandardUsers: '2-50 users',
        pricingEnterpriseUsers: '51+ users',
        pricingPerPerson: '/user/mo',
        pricingPerson: 'user',
        pricingContactUs: 'Contact Us',
        pricingUnlimitedChat: 'Unlimited internal chat',
        pricingPublicLink: 'Public link quota',
        pricingTimesMonth: '/mo',
        pricingTimesPersonMonth: '/user/mo',
        pricingUnlimitedKB: 'Unlimited knowledge bases',
        pricingStorage: 'Storage',
        pricingCustom: 'Custom',
        pricingPopular: 'Recommended',
        pricingMultiUser: 'Multi-user accounts',
        pricingSharedKB: 'Shared knowledge base',
        pricingRoleOwnerMember: 'Owner/Member roles',
        pricingAllStandardFeatures: 'All Standard features',
        pricingDedicatedSupport: 'Dedicated support',
        pricingFeatureComparison: 'Feature Comparison',
        pricingFeature: 'Feature',
        pricingAccountManagement: 'Account Management',
        pricingInviteMembers: 'Invite members',
        pricingKnowledgeBase: 'Knowledge Base',
        pricingPersonalKB: 'Personal knowledge base',
        pricingRolePermission: 'Role & Permission',
        pricingRoleOwner: 'Owner',
        pricingRoleMember: 'Member',
        pricingOverage: 'Public access paused when exceeded, resets next month',
        pricingNote: 'All plans include 7-day free trial · Upgrade or downgrade anytime',
        
        // CTA Section
        ctaTitle: 'Start Now, Quick Payback',
        ctaSubtitle: 'Maximize enterprise knowledge value, the smartest investment',
        ctaLowCost: 'Unbeatable low cost',
        ctaQuickPayback: 'Quick investment recovery',
        ctaSave240: 'Save ¥5.82M/year',
        ctaCostReduction: 'Continuous cost reduction',
        ctaZeroTech: 'Zero technical barrier',
        ctaQuickDeploy: 'Deploy in 3 minutes',
        month: '/mo',
        bookDemoExec: 'Book Executive Demo',
        trustSecurity: 'Enterprise security certified',
        trustPrivate: 'Private deployment supported',
        trustSupport: '24/7 technical support',
        
        // Footer
        footerDesc: 'Enterprise AI Knowledge Base Management Platform\nMake enterprise knowledge accessible. Reduce knowledge acquisition costs through AI smart Q&A, boost work efficiency',
        footerProduct: 'Product',
        footerSolution: 'Solutions',
        footerFeatures: 'Features',
        footerCases: 'Customer Cases',
        footerPricing: 'Pricing',
        footerResources: 'Resources',
        footerDocs: 'Documentation',
        footerAPI: 'API Docs',
        footerBlog: 'Blog',
        footerHelp: 'Help Center',
        footerContact: 'Contact Us',
        footerLocation: 'Japan · Tokyo',
        footerPrivacy: 'Privacy Policy',
        footerTerms: 'Terms of Service',
      },
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['zh', 'ja', 'en'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      // 1.2.53: 将 localStorage 放在最前面，确保用户手动选择的语言优先生效
      // 修复：登录页面选择日语后，进入管理页面变成中文的问题
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    }
  });

export default i18n;

